// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:35:05.626Z
// Property: Waters Edge Apartments (ID: 6767906449165643)
// Collections: 21 amenities, 3 floorplans (live), 27 photos, 62 POIs, 3 reviews, 1 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449165643",
  "property_external_id": "fpy2npv",
  "property_zillow_url": "https://www.zillow.com/homedetails/4317-SW-22nd-St-APT-2304-Oklahoma-City-OK-73108/312771071_zpid/",
  "property_apartments_url": "https://www.apartments.com/waters-edge-apartments-oklahoma-city-ok/fpy2npv/",
  "property_google_business_url": "https://www.google.com/maps/place/Waters+Edge/data=!4m2!3m1!1s0x0:0x7d479ce2329e5bcb?sa=X&ved=2ahUKEwjMkNGJg72SAxV-yckDHckeMHoQ_BJ6BAg2EAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "waters-edge-apartments",
  "property_name": "Waters Edge Apartments",
  "property_website_url": "https://www.caseusa.com/apartments/ok/oklahoma-city/waters-edge/",
  "property_domain": null,
  "property_address": "4317 SW 22nd St.",
  "property_full_address": "4317 SW 22nd St., Oklahoma City, OK, 73108",
  "property_address_1": "4317 SW 22nd St.",
  "property_address_2": null,
  "property_address_city": "Oklahoma City",
  "property_address_state": "OK",
  "property_address_zip_full": null,
  "property_address_zip": "73108",
  "property_address_country": "US",
  "property_address_county": "Oklahoma County",
  "property_neighborhood_address": "W South Oklahoma City",
  "property_address_latitude": "35.4444",
  "property_address_longitude": "-97.5948",
  "property_email": "watersedge@caseusa.com",
  "property_phone": "(405) 267-7241",
  "property_call_tracking_phone": "855-906-4626",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "At Waters Edge Apartments in Oklahoma City, elevate your lifestyle with meticulously designed studio, one, and two-bedroom layouts. Enjoy amenities like a sparkling pool, fitness center, and pet-friendly play area, all nestled by serene lake access. Picture your life here—schedule a tour and find your perfect home today! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "Welcome to Waters Edge Apartments, your serene retreat in the heart of Oklahoma City, Oklahoma. Offering a diverse selection of floor plans, including cozy studios, spacious one-bedroom, and inviting two-bedroom apartments, we cater to your unique lifestyle needs. Each home is thoughtfully designed with modern amenities such as air conditioning, high-speed internet access, and fully equipped kitchens with a refrigerator, dishwasher, and oven. Additional features like walk-in closets and convenient in-unit washers/dryers enhance your comfort and convenience.\n\nStep outside and immerse yourself in our resort-style amenities. Dive into our sparkling swimming pool, break a sweat in our state-of-the-art fitness center, or enjoy a leisurely afternoon at the sundeck and cabana overlooking the tranquil waterfront. Our community is pet-friendly, complete with a dedicated play area for your furry companions. For those who love the outdoors, discover walking and biking trails that wind through our picturesque grounds, perfect for enjoying a relaxing stroll.\n\nAt Waters Edge, we prioritize your ease and comfort with on-site maintenance, a property manager available to assist you, as well as curbside trash pickup. Our wheelchair-accessible apartments and community spaces ensure everyone can enjoy our vibrant living environment. \n\nWhether you prefer the lively atmosphere of Oklahoma City or the peacefulness of lakeside living, Waters Edge Apartments provides the perfect balance. Don't miss the opportunity to elevate your living experience. Find your new home today—browse our availability or schedule a tour to visit our beautiful community!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019fb44b-be7f-74cd-bb11-c07d324cf8c1.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor wooden deck with tables and chairs, adjacent to a building and tennis courts.",
    "public_id": "019fb44b-be7f-74cd-bb11-c07d324cf8c1",
    "storage_key": "property/6767906449165643/019fb44b-be7f-74cd-bb11-c07d324cf8c1.webp",
    "width": 1280,
    "height": 1025
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "368",
  "property_year_built": "1985",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "97.82608695652173",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "100",
  "property_pet_restrictions": "Breed restrictions apply",
  "property_pet_policy_description": "No weight limit. Maximum of two pets allowed. Breed restrictions apply. Pet rent is $30 per pet per month. $500 fee per pet (non‑refundable). Service animals are not considered pets; pet fees and pet rent do not apply to them.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://watersegdeapartmentsokc.securecafe.com/onlineleasing/waters-edge-apartments-2/floorplans.aspx",
  "property_resident_portal_url": "https://watersegdeapartmentsokc.securecafe.com/residentservices/waters-edge-apartments-2/userlogin.aspx",
  "property_apply_now_url": "https://watersegdeapartmentsokc.securecafe.com/onlineleasing/waters-edge-apartments-2/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019cfb4c-f31f-71c8-af84-c940e15c74f6.webp",
  "property_primary_logo_media": {
    "alt_text": "Waters Edge Apartments logo",
    "public_id": "019cfb4c-f31f-71c8-af84-c940e15c74f6",
    "storage_key": "property/6767906449165643/019cfb4c-f31f-71c8-af84-c940e15c74f6.webp",
    "width": 250,
    "height": 210
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019cfb4d-f0d1-72ae-81b5-072384a6882e.webp",
  "property_secondary_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb4d-f0d1-72ae-81b5-072384a6882e",
    "storage_key": "property/6767906449165643/019cfb4d-f0d1-72ae-81b5-072384a6882e.webp",
    "width": 325,
    "height": 325
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019cfb4e-106c-74eb-857b-e1e86fe53323.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Waters Edge Apartments logo",
    "public_id": "019cfb4e-106c-74eb-857b-e1e86fe53323",
    "storage_key": "property/6767906449165643/019cfb4e-106c-74eb-857b-e1e86fe53323.webp",
    "width": 250,
    "height": 210
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019cfb4e-1809-713c-a691-025a86d37275.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Waters Edge Apartments logo",
    "public_id": "019cfb4e-1809-713c-a691-025a86d37275",
    "storage_key": "property/6767906449165643/019cfb4e-1809-713c-a691-025a86d37275.webp",
    "width": 250,
    "height": 210
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#000000",
  "property_secondary_color": "#26a9e0",
  "property_font_color": null,
  "property_color_4": "#eae0c8",
  "property_color_3": "#125372",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "396 - 896",
  "property_sqft_min": "396",
  "property_sqft_max": "896",
  "property_price_range": "749 - 1044",
  "property_price_min": "749",
  "property_price_max": "1044",
  "property_available_units": 7,
  "property_facebook_url": "https://www.facebook.com/WatersedgeOKC/videos/",
  "property_instagram_url": "https://www.instagram.com/watersedgeokc/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ1ZeBzt0RsocRy1ueMuKcR30",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/waters-edge-oklahoma-city",
  "property_tiktok_url": "https://www.tiktok.com/@watersedgeokc",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Waters Edge Apartments",
  "property_home_romance_title": "Embrace the Joy of Living in Your Dream Apartment",
  "property_home_amenities_blurb": "Welcome to Waters Edge Apartments in Oklahoma City, where comfort meets convenience. Choose from stylish studio, one, or two-bedroom layouts, each designed for modern living. Immerse yourself in a vibrant community with a pool, fitness center, pet play area, and scenic walking trails. Your perfect home awaits!",
  "property_home_floorplans_blurb": "At Waters Edge Apartments in the heart of Oklahoma City, we offer a diverse range of floor plans to fit your lifestyle. From cozy studios to spacious two-bedroom suites, your ideal living space awaits. Browse our available apartment homes today and envision your new beginning by the water's edge.",
  "property_home_gallery_blurb": "Nestled on the serene shores of Oklahoma City, Waters Edge Apartments offers captivating studio, one, and two-bedroom floor plans tailored for your lifestyle. Enjoy refreshing swims in the pool, invigorating workouts in our fitness center, or leisurely strolls along scenic walking trails. Picture yourself unwinding on your private balcony, surrounded by comfort and convenience!",
  "property_home_neighborhood_blurb": "Nestled in the heart of Oklahoma City, Waters Edge Apartments offers studio, one, and two-bedroom floor plans tailored to your lifestyle. Step outside to vibrant attractions like the Oklahoma City National Memorial, Myriad Botanical Gardens, and the lively Bricktown River Walk. Dive into a community brimming with life and convenience!",
  "property_home_reviews_blurb": "Nestled amidst serene ponds and picturesque tree lines, Waters Edge Apartments offers a hidden oasis in Oklahoma City. “It’s peaceful…all the tenants I’ve met are really nice and quiet.” Embrace nature with walking trails, courts, and a supportive community. Experience a tranquil lifestyle in the heart of the city!",
  "property_neighborhood_blurb": "At Waters Edge Apartments in Oklahoma City, enjoy a vibrant neighborhood rich in culture and convenience. Stroll through Scissortail Park, soak in art at the Oklahoma City Museum, or catch a game at Chickasaw Bricktown Ballpark. Experience local charm while choosing from a variety of spacious floor plans.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Waters Edge Apartments in Oklahoma City, residents enjoy lake access and resort-style living. Dive into our shimmering pool, break a sweat in the fitness center, or unwind on your private balcony. With thoughtful amenities like a pet play area and walking trails, your ideal lifestyle awaits. Explore our amazing community amenities today!",
  "property_applynow_blurb": "At Waters Edge Apartments in Oklahoma City, comfort meets lifestyle with thoughtfully designed studio, one, and two-bedroom homes. Enjoy refreshing swims, pet-friendly play areas, and scenic walking trails, all while relishing lake access and modern amenities. Transform your living experience and lease online today for your perfect home!",
  "property_contactus_blurb": "At Waters Edge Apartments in Oklahoma City, you'll find the perfect floor plan tailored to your lifestyle—from cozy studios to spacious two-bedroom homes. Each layout offers a unique blend of comfort and style. Have questions? Our dedicated leasing team is ready to assist you today!",
  "property_faqs_blurb": "At Waters Edge Apartments in Oklahoma City, our diverse floor plans—studio, one-bedroom, and two-bedroom—cater to your lifestyle needs. Curious about our community? Dive into our FAQs page for insights and answers that guide your journey to comfortable living. Your ideal apartment awaits!",
  "property_floorplans_blurb": "At Waters Edge Apartments in Oklahoma City, unique living awaits! Choose from a stylish studio, spacious one-bedroom, or comfortable two-bedroom layouts tailored to your lifestyle. Each floor plan is designed with your comfort in mind. Browse our available apartment homes today and find the perfect fit for your next adventure!",
  "property_gallery_blurb": "At Waters Edge Apartments in Oklahoma City, picture yourself in stylish studio, one, or two-bedroom homes, complete with breathtaking lake views. Relax by the pool, enjoy the sun on the sundeck, or get active on the volleyball court—all within a welcoming, smoke-free environment. Your ideal lifestyle awaits!",
  "property_interactivemap_blurb": "At Waters Edge Apartments in Oklahoma City, your perfect home awaits with stylish studio to two-bedroom layouts. Relish in premier amenities like a sparkling pool, fitness center, and serene lake access. Use our interactive community map to explore available units and find your ideal living space today!",
  "property_pets_blurb": "Welcome to Waters Edge Apartments in vibrant Oklahoma City, where comfort meets convenience. Your furry friends will feel right at home with our flexible pet policy. Enjoy a peaceful lifestyle alongside nature, with scenic views and spacious living. Make every day extraordinary in your new sanctuary!",
  "property_referafriend_blurb": "At Waters Edge Apartments in Oklahoma City, our inviting studio, one-bedroom, and two-bedroom floor plans are designed for comfort and style. Share the joy of living in our vibrant community—great friends make great neighbors! Refer a friend today and enhance your living experience together!",
  "property_residentaccess_blurb": "At Waters Edge Apartments in vibrant Oklahoma City, our diverse floor plans—studios, one-bedroom, and two-bedroom options—cater to your unique lifestyle. Seamlessly manage your residency with our resident portal, where you can effortlessly pay rent, schedule maintenance, and much more—all at your fingertips. Ready to streamline your living experience?",
  "property_reviews_blurb": "Nestled among serene landscapes, Waters Edge Apartments offers an oasis of tranquility right in Oklahoma City. Residents rave about the peaceful vibes, saying it's “a relaxing place to live.” With beautiful ponds, walking trails, and excellent management, it's the perfect hidden gem for those seeking comfort and community.",
  "property_created_at": "1753982397454",
  "property_scheduletour_blurb": "At Waters Edge Apartments in Oklahoma City, choose from thoughtfully designed studio, one-bedroom, and two-bedroom floor plans that fit your lifestyle. Experience vibrant community living and unparalleled comfort. Curious about life here? Schedule a tour and hear directly from our residents about their exceptional experiences!",
  "property_thankyou_blurb": "Thank you for reaching out to Waters Edge Apartments in vibrant Oklahoma City! Your interest in our stylish studio, one-bedroom, and two-bedroom floor plans is appreciated. Our team will connect with you soon to guide you in finding your perfect home amidst scenic surroundings and modern comforts.",
  "property_virtualtours_blurb": "Welcome to Waters Edge Apartments in vibrant Oklahoma City, where modern living meets comfort. Choose from cozy studios to spacious two-bedroom layouts, each designed for your lifestyle. Immerse yourself in our community's charm by taking a virtual tour today and envision your future home with us!",
  "property_copyright": "2025 All Rights Reserved. Waters Edge Apartments",
  "property_seo_title_home": "Waters Edge Apartments |  Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_home": "Discover Waters Edge Apartments in OKC! From studios to 2-bedrooms, enjoy a pool, fitness center, and lake access. Your perfect home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Oklahoma City, Oklahoma Apartments for Rent",
  "property_seo_description_floorplans": "Discover your ideal home at Waters Edge Apartments in OKC! Choose from stylish studios, cozy one-bedrooms, or spacious two-bedrooms.",
  "property_seo_title_amenities": "Amenities | Oklahoma City, Oklahoma Apartments for Rent",
  "property_seo_description_amenities": "Experience luxury at Waters Edge Apartments in OKC! Enjoy waterfront views, a vibrant pool, and top-notch amenities for every lifestyle.",
  "property_seo_title_gallery": "Gallery | Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_gallery": "Picture life at Waters Edge Apartments in OKC! Enjoy stunning views, modern amenities like a pool and fitness center, and spacious floor plans. Live the dream!",
  "property_seo_title_virtualtours": "Virtual Tours | Waters Edge Apartments Apartments",
  "property_seo_description_virtualtours": "Step into your dream home at Waters Edge Apartments in OKC! Take a virtual tour and see spacious studio, one, and two-bedroom floor plans today!",
  "property_seo_title_interactivemap": "Interactive Map | Waters Edge Apartments Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at Waters Edge Apartments in OKC! Use our map to explore floor plans and amenities by the lake!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_neighborhood": "Experience the vibrant neighborhood surrounding Waters Edge Apartments in Oklahoma City. Uncover local gems and attractions just steps from your new home!",
  "property_seo_title_contact": "Contact Us | Waters Edge Apartments",
  "property_seo_description_contact": "Connect with Waters Edge Apartments in OKC! Our friendly leasing team is ready to help you find your perfect studio, one, or two-bedroom home.",
  "property_seo_title_faqs": "FAQs | Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_faqs": "Find answers to your questions about Waters Edge Apartments in Oklahoma City. Enjoy lakeside living with top-notch amenities and spacious floor plans.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_reviews": "At Waters Edge Apartments in OKC, residents enjoy lakeside living with top-notch amenities. Read their reviews and envision your future home—your oasis awaits!",
  "property_seo_title_applynow": "Apply Now | Apartments in Oklahoma City, Oklahoma",
  "property_seo_description_applynow": "Experience modern living at Waters Edge Apartments in OKC! Enjoy stunning water views, top-notch amenities, and various floor plans. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Waters Edge Apartments",
  "property_seo_description_residentaccess": "Unlock seamless living at Waters Edge Apartments! Log in now to pay rent, request maintenance, and connect with your community in vibrant Oklahoma City.",
  "property_seo_title_referafriend": "Refer A Friend | Waters Edge Apartments",
  "property_seo_description_referafriend": "Refer a friend to Waters Edge Apartments in Oklahoma City! Enjoy a vibrant community where great friends become cherished neighbors. Share the love today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Waters Edge Apartments",
  "property_seo_description_scheduletour": "Experience the tranquility of Waters Edge Apartments in Oklahoma City. Secure your dream home—schedule a tour today and embrace lakeside living at its finest!",
  "property_seo_title_privacy": "Privacy Policy | Waters Edge Apartments",
  "property_seo_description_privacy": "Your privacy matters at Waters Edge Apartments in Oklahoma City. Read our policy to understand how we protect your information. Stay informed and secure!",
  "property_seo_title_accessibility": "Website Accessibility | Waters Edge Apartments",
  "property_seo_description_accessibility": "Join Waters Edge Apartments in OKC, where we prioritize digital inclusion and offer accessibility along with comfort and convenience for all.",
  "property_seo_title_sitemap": "Sitemap | Waters Edge Apartments",
  "property_seo_description_sitemap": "Navigate your way to comfortable living at Waters Edge Apartments in OKC! Check out our sitemap for easy access to all our amenities and services.",
  "property_seo_title_thankyou": "Thank You | Waters Edge Apartments",
  "property_seo_description_thankyou": "Thank you for reaching out to Waters Edge Apartments in OKC! Our team will be in touch shortly to help you find your perfect new home by the water.",
  "property_seo_title_pets": "Pet Policy | Apartments in Oklahoma City, OK",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787866159706",
  "amenities": [
    {
      "id": "ec_84e03d1049e5f61e1d3de611",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "yardi",
      "external_id": "127397489",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f1022ca90f125c2cf362e329",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "yardi",
      "external_id": "127397490",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2d04c0f02354f25ac5dc2a4f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "yardi",
      "external_id": "127397491",
      "title": "Availability 24 Hours",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fc98286c6877ce2de74c7163",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "yardi",
      "external_id": "127397494",
      "title": "Carport",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7395e20c397d2c923bd70203",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "yardi",
      "external_id": "127397497",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bcd408137fe220d0bcd97309",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "yardi",
      "external_id": "127397498",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f7b3658653873ac4b05a0dac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "yardi",
      "external_id": "127397499",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_28a2e8007dd81f44cdfa5824",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "yardi",
      "external_id": "127397500",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c2b70d51b87421905ebdce6d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "yardi",
      "external_id": "127397501",
      "title": "Package Receiving",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4b6591ae34bd5f50ab37e493",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "yardi",
      "external_id": "128017311",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3d9e2daecca50a74bbb8aa2b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "yardi",
      "external_id": "128042567",
      "title": "Preinstalled WiFi Modem Powered by Cox",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_033855fede6342b44fb8d0c5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "yardi",
      "external_id": "127398957",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2c9eb923cc9f00e34a2f7132",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "yardi",
      "external_id": "127398958",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fffee5153be526ebfc50b176",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "yardi",
      "external_id": "127398959",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c3a4782128fe72f7b80dd981",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "yardi",
      "external_id": "127398960",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_69dec99abf604e871e696003",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "yardi",
      "external_id": "127398961",
      "title": "View",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_63f02528b459ccbb1e5fa864",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "yardi",
      "external_id": "127398962",
      "title": "Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1d9cc39c837721a728ad769c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "yardi",
      "external_id": "127398963",
      "title": "Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b2b386dfb0553e6165c53449",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "yardi",
      "external_id": "127398964",
      "title": "Extra Storage",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1e3f6393b910743ce17bbfdd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "yardi",
      "external_id": "127398965",
      "title": "Wheelchair Access",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e69a08e044d08816ac5a1183",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "yardi",
      "external_id": "127398966",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_37404df0-887a-44f2-8fb5-8fba465b9243",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019faa4d-d499-71fc-8474-08250f38d4a8.webp",
      "image_media": {
        "alt_text": "Kitchen and dining area with wooden cabinets, white appliances, and a dark wood dining table.",
        "public_id": "019faa4d-d499-71fc-8474-08250f38d4a8",
        "storage_key": "property/6767906449165643/019faa4d-d499-71fc-8474-08250f38d4a8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy cooking and dining in this well-appointed kitchen and dining area, featuring ample cabinet space and a comfortable dining nook.",
      "link": "",
      "alt_text": "Kitchen and dining area with wooden cabinets, white appliances, and a dark wood dining table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_758cb0fe-9b48-48a1-ba59-88d17c3fce7f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019faa4d-c51b-764a-80c5-b5b8d2eb0a5d.webp",
      "image_media": {
        "alt_text": "Living room and dining area with modern farmhouse decor.",
        "public_id": "019faa4d-c51b-764a-80c5-b5b8d2eb0a5d",
        "storage_key": "property/6767906449165643/019faa4d-c51b-764a-80c5-b5b8d2eb0a5d.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious living and dining area featuring modern farmhouse decor, perfect for relaxing or entertaining guests.",
      "link": "",
      "alt_text": "Living room and dining area with modern farmhouse decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4738b305-e56e-4f54-8a2e-718c784b929c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019faa4d-d918-746a-bf53-69e0ef7d39c2.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstand, dresser, and window.",
        "public_id": "019faa4d-d918-746a-bf53-69e0ef7d39c2",
        "storage_key": "property/6767906449165643/019faa4d-d918-746a-bf53-69e0ef7d39c2.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a queen-size bed with decorative pillows, a wooden dresser, and a nightstand with a lamp. Decorated with framed wall art.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, nightstand, dresser, and window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1c55732a-ddd1-4e6a-9dd8-9a908f03f76e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019faa4d-b056-750f-a97f-0c5a4d60e9dd.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with red brick facades and peaked roofs.",
        "public_id": "019faa4d-b056-750f-a97f-0c5a4d60e9dd",
        "storage_key": "property/6767906449165643/019faa4d-b056-750f-a97f-0c5a4d60e9dd.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Exterior view of apartment buildings with red brick facades and peaked roofs. Features pathways and green spaces.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with red brick facades and peaked roofs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c2d73e8a-f8d0-4517-824c-e06ae42283ee",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019faa4d-d85a-73e7-a7cd-a14239cff6e6.webp",
      "image_media": {
        "alt_text": "Kitchen with white appliances, wood cabinets, and a coffee maker.",
        "public_id": "019faa4d-d85a-73e7-a7cd-a14239cff6e6",
        "storage_key": "property/6767906449165643/019faa4d-d85a-73e7-a7cd-a14239cff6e6.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Galley kitchen with white appliances, ample wood cabinetry, and a coffee maker for your morning brew.",
      "link": "",
      "alt_text": "Kitchen with white appliances, wood cabinets, and a coffee maker.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_05523c3e-e706-4a21-b4a6-1584fed96736",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019faa4d-a9d5-744d-831a-6c27cc8f730d.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-size bed, decorative wreath, and nightstand with lamp.",
        "public_id": "019faa4d-a9d5-744d-831a-6c27cc8f730d",
        "storage_key": "property/6767906449165643/019faa4d-a9d5-744d-831a-6c27cc8f730d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax and unwind in the comfortable bedroom, featuring a stylish bed, ample lighting, and charming decor.",
      "link": "",
      "alt_text": "Cozy bedroom with a queen-size bed, decorative wreath, and nightstand with lamp.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_09c8d0df-15fa-4f84-bffd-dbb5f1760091",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019faa4d-a5c8-75aa-80a8-ed1cfb78ca32.webp",
      "image_media": {
        "alt_text": "Spacious community lounge area with a modern fireplace, comfortable seating, and a full-service kitchen bar.",
        "public_id": "019faa4d-a5c8-75aa-80a8-ed1cfb78ca32",
        "storage_key": "property/6767906449165643/019faa4d-a5c8-75aa-80a8-ed1cfb78ca32.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and socialize in our beautifully appointed community lounge, featuring a cozy fireplace, ample seating, and a convenient kitchen bar perfect for gatherings.",
      "link": "",
      "alt_text": "Spacious community lounge area with a modern fireplace, comfortable seating, and a full-service kitchen bar.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1c64ce59-dde0-4004-958b-61d99077d3e6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019faa4d-b331-749e-a758-95206ad691c3.webp",
      "image_media": {
        "alt_text": "Gym equipment including treadmills, elliptical, and weight machine.",
        "public_id": "019faa4d-b331-749e-a758-95206ad691c3",
        "storage_key": "property/6767906449165643/019faa4d-b331-749e-a758-95206ad691c3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our fully-equipped fitness center, featuring cardio machines and strength training equipment for a great workout.",
      "link": "",
      "alt_text": "Gym equipment including treadmills, elliptical, and weight machine.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1c35f1cd-2656-4f88-a530-0997056865eb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019faa4d-add6-72ec-b13a-b4169aac64e9.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, dresser, and deer head wall decor.",
        "public_id": "019faa4d-add6-72ec-b13a-b4169aac64e9",
        "storage_key": "property/6767906449165643/019faa4d-add6-72ec-b13a-b4169aac64e9.webp",
        "width": 3072,
        "height": 2034
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a plush queen-size bed, a dark wood dresser with decorative lamps, and unique deer head wall art for a stylish touch.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, dresser, and deer head wall decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a70ae4f8-1633-4748-a62b-2c4671f82608",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019faa4d-99c8-734e-bf1d-accccad82c31.webp",
      "image_media": {
        "alt_text": "Bathroom with a bathtub, toilet, and vanity.",
        "public_id": "019faa4d-99c8-734e-bf1d-accccad82c31",
        "storage_key": "property/6767906449165643/019faa4d-99c8-734e-bf1d-accccad82c31.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A clean and well-maintained bathroom featuring a bathtub with a decorative shower curtain, a toilet, and a vanity with a sink and mirror.",
      "link": "",
      "alt_text": "Bathroom with a bathtub, toilet, and vanity.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c9e7fd18-c834-4d04-b0db-f4e6c45da94b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019faa4b-2981-737d-b79d-7f7499a58eec.webp",
      "image_media": {
        "alt_text": "Wooden pier extending into a lake with a gazebo, a fountain, and ducks swimming.",
        "public_id": "019faa4b-2981-737d-b79d-7f7499a58eec",
        "storage_key": "property/6767906449165643/019faa4b-2981-737d-b79d-7f7499a58eec.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the serene lake with a pier, gazebo, and abundant wildlife. A perfect spot for relaxation and enjoying the outdoors.",
      "link": "",
      "alt_text": "Wooden pier extending into a lake with a gazebo, a fountain, and ducks swimming.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_13ce4efc-511f-4ccd-9f54-2f656ae6b8c2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019faa4b-23ed-77e4-857e-d6824b88a546.webp",
      "image_media": {
        "alt_text": "Aerial view of two tennis courts with white lines and nets.",
        "public_id": "019faa4b-23ed-77e4-857e-d6824b88a546",
        "storage_key": "property/6767906449165643/019faa4b-23ed-77e4-857e-d6824b88a546.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a friendly match on our well-maintained tennis courts, perfect for residents who love to stay active.",
      "link": "",
      "alt_text": "Aerial view of two tennis courts with white lines and nets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3e460c13-12b3-4a17-81d5-2bb0ce15436d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019faa4b-266a-74d8-9f70-b422a34096cc.webp",
      "image_media": {
        "alt_text": "Tennis court with a fenced perimeter, adjacent to a lake with a gazebo and pier.",
        "public_id": "019faa4b-266a-74d8-9f70-b422a34096cc",
        "storage_key": "property/6767906449165643/019faa4b-266a-74d8-9f70-b422a34096cc.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a friendly match on our pristine tennis courts, or relax by the serene lake, complete with a charming gazebo and pier.",
      "link": "",
      "alt_text": "Tennis court with a fenced perimeter, adjacent to a lake with a gazebo and pier.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3b964a0c-562f-4e83-a508-8c2d5ce9912b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019faa4b-2074-725f-9d78-7ce020c2b6e6.webp",
      "image_media": {
        "alt_text": "Aerial view of a tranquil pond with a wooden pier and gazebo, featuring fountains and ducks.",
        "public_id": "019faa4b-2074-725f-9d78-7ce020c2b6e6",
        "storage_key": "property/6767906449165643/019faa4b-2074-725f-9d78-7ce020c2b6e6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the serene beauty of our community's pond, complete with a picturesque pier and gazebo, perfect for peaceful reflection or enjoying the outdoors.",
      "link": "",
      "alt_text": "Aerial view of a tranquil pond with a wooden pier and gazebo, featuring fountains and ducks.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_55a67a42-dbe8-4072-85d2-6ef35ec1a925",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019faa4b-0eb5-7508-a449-229e396dc635.webp",
      "image_media": {
        "alt_text": "Wooden pier extending into a calm lake with a gazebo at the end.",
        "public_id": "019faa4b-0eb5-7508-a449-229e396dc635",
        "storage_key": "property/6767906449165643/019faa4b-0eb5-7508-a449-229e396dc635.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the serene beauty of our community lake, complete with a scenic pier and gazebo, perfect for a peaceful afternoon.",
      "link": "",
      "alt_text": "Wooden pier extending into a calm lake with a gazebo at the end.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f43dc25c-cd83-448d-9465-a0590e5960bd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019faa4b-0f50-7173-8a18-f22971a35c68.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a lake view.",
        "public_id": "019faa4b-0f50-7173-8a18-f22971a35c68",
        "storage_key": "property/6767906449165643/019faa4b-0f50-7173-8a18-f22971a35c68.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by lush landscaping and featuring comfortable lounge seating. Perfect for relaxation and fun.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and a lake view.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_403847dc-3e3d-4c82-adc8-8d9c86a4a6bf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019faa4b-084d-7259-9aa0-1af2dffc18c1.webp",
      "image_media": {
        "alt_text": "Apartment buildings by a pond with a tennis court in the background.",
        "public_id": "019faa4b-084d-7259-9aa0-1af2dffc18c1",
        "storage_key": "property/6767906449165643/019faa4b-084d-7259-9aa0-1af2dffc18c1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy scenic views of the pond and community grounds at our apartment complex, complete with a tennis court for recreation.",
      "link": "",
      "alt_text": "Apartment buildings by a pond with a tennis court in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d7d48b72-64a3-4de6-9be0-f79daa784411",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019faa4a-edc7-736e-b053-73a2aa09b93e.webp",
      "image_media": {
        "alt_text": "Cozy living room with a large gray sectional sofa, armchair, wooden coffee table, and console table.",
        "public_id": "019faa4a-edc7-736e-b053-73a2aa09b93e",
        "storage_key": "property/6767906449165643/019faa4a-edc7-736e-b053-73a2aa09b93e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into comfort in this inviting living room, featuring plush seating, a stylish coffee table, and ample natural light.",
      "link": "",
      "alt_text": "Cozy living room with a large gray sectional sofa, armchair, wooden coffee table, and console table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_797dc9b6-3ba4-4827-bbb6-4173073f9308",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019faa4a-f4dd-778a-a95b-2ed917607695.webp",
      "image_media": {
        "alt_text": "Kitchen with wood cabinets, white refrigerator, stove, microwave, and washer/dryer visible in background.",
        "public_id": "019faa4a-f4dd-778a-a95b-2ed917607695",
        "storage_key": "property/6767906449165643/019faa4a-f4dd-778a-a95b-2ed917607695.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Bright and functional kitchen featuring ample wood cabinetry, a white refrigerator, stove, microwave, and convenient in-unit laundry facilities.",
      "link": "",
      "alt_text": "Kitchen with wood cabinets, white refrigerator, stove, microwave, and washer/dryer visible in background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_524fbbc2-72e2-4c4b-b950-4cb648da9055",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019faa4a-ea54-709b-83ca-1039c1c4fa1b.webp",
      "image_media": {
        "alt_text": "Bathroom with white tub and shower curtain, toilet, and vanity with sink.",
        "public_id": "019faa4a-ea54-709b-83ca-1039c1c4fa1b",
        "storage_key": "property/6767906449165643/019faa4a-ea54-709b-83ca-1039c1c4fa1b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Clean and functional bathroom featuring a white bathtub with a decorative shower curtain, a toilet, and a vanity with a sink and mirror.",
      "link": "",
      "alt_text": "Bathroom with white tub and shower curtain, toilet, and vanity with sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0f279589-83cd-4732-bf37-23202f9396ec",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019faa4a-e330-71dd-88ef-c089d4870452.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings and a tennis court in autumn.",
        "public_id": "019faa4a-e330-71dd-88ef-c089d4870452",
        "storage_key": "property/6767906449165643/019faa4a-e330-71dd-88ef-c089d4870452.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Discover comfortable living in our apartment community, featuring a tennis court and beautiful autumn foliage.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings and a tennis court in autumn.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ebfd23e7-89c2-4c5c-9190-3092f51bd9c7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019faa4a-ef4e-7519-b574-ed4513af5b1f.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, dresser, and chair.",
        "public_id": "019faa4a-ef4e-7519-b574-ed4513af5b1f",
        "storage_key": "property/6767906449165643/019faa4a-ef4e-7519-b574-ed4513af5b1f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Comfortable and stylish bedroom featuring a queen-size bed with plaid bedding, a dark wood dresser, and a cozy accent chair. Perfect for relaxation.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, dresser, and chair.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_66eb8961-c481-44b8-a4a9-b21a29eda30a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019faa4a-e318-74e6-99aa-fd301a30f710.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, ceiling fan, and a doorway to the bathroom.",
        "public_id": "019faa4a-e318-74e6-99aa-fd301a30f710",
        "storage_key": "property/6767906449165643/019faa4a-e318-74e6-99aa-fd301a30f710.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a plush queen-size bed, a stylish ceiling fan, and convenient access to the en-suite bathroom.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, ceiling fan, and a doorway to the bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b3af4cdf-3505-400f-8269-e3a34b461100",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019faa4a-e32d-76ea-a2ae-8f08154a1677.webp",
      "image_media": {
        "alt_text": "Living room with a leather armchair, coffee table, and a decorative console table.",
        "public_id": "019faa4a-e32d-76ea-a2ae-8f08154a1677",
        "storage_key": "property/6767906449165643/019faa4a-e32d-76ea-a2ae-8f08154a1677.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a comfortable leather armchair, a rustic coffee table, and a stylish console table with decorative items. Perfect for relaxation.",
      "link": "",
      "alt_text": "Living room with a leather armchair, coffee table, and a decorative console table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8eeb967e-da52-4f68-9743-b2b46e4083ac",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019faa4a-cf04-7187-87ed-e73872157d1a.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, elliptical, and weight machines. Motivational posters adorn the wall.",
        "public_id": "019faa4a-cf04-7187-87ed-e73872157d1a",
        "storage_key": "property/6767906449165643/019faa4a-cf04-7187-87ed-e73872157d1a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring cardio machines and strength training equipment. Motivational posters will inspire your workout.",
      "link": "",
      "alt_text": "Fitness center with treadmills, elliptical, and weight machines. Motivational posters adorn the wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d0f500d5-dda7-4cce-8796-0f0f76a4a67a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019faa4a-c131-700c-94f7-19d1dab1d43e.webp",
      "image_media": {
        "alt_text": "Modern gym with treadmills, elliptical, and weight machines, large mirrors, and large windows.",
        "public_id": "019faa4a-c131-700c-94f7-19d1dab1d43e",
        "storage_key": "property/6767906449165643/019faa4a-c131-700c-94f7-19d1dab1d43e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring cardio machines, weight training equipment, and open space for your workout.",
      "link": "",
      "alt_text": "Modern gym with treadmills, elliptical, and weight machines, large mirrors, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_02e21c74-d035-4d5f-8012-6be763a41ff4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019faa4a-be7b-755e-95dc-a075b7d2e8c0.webp",
      "image_media": {
        "alt_text": "Kitchen and living room area of an apartment.",
        "public_id": "019faa4a-be7b-755e-95dc-a075b7d2e8c0",
        "storage_key": "property/6767906449165643/019faa4a-be7b-755e-95dc-a075b7d2e8c0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Open concept living space featuring a kitchen with ample cabinet space and a comfortable living room area.",
      "link": "",
      "alt_text": "Kitchen and living room area of an apartment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_f123c51d-fbdc-4c67-85ad-7c29fe89479b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "custom",
      "poi_name": "Cattlemen's Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "1309 S Agnew Ave, Oklahoma City, OK 73108, USA",
      "poi_short_description": "Old-timey steakhouse – known for aged steak, burgers, chicken-fried steak, and breakfast fare.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, including ribeye, filet mignon, and T-bone, as well as lamb fries, chicken fried steak, and a house salad with homemade dressing. They highlight the reasonable prices, especially for lunch specials, and the classic, old-school Western atmosphere. They also like the friendly and attentive service provided by the staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-b267-76c2-b92f-f06b5609553e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b267-76c2-b92f-f06b5609553e",
        "storage_key": "property/6767906449165643/019d2709-b267-76c2-b92f-f06b5609553e.webp",
        "width": 1121,
        "height": 1280
      },
      "poi_business_url": "https://cattlemensrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16503287899146177443&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cattlemens-steakhouse",
      "poi_latitude": "35.4523741",
      "poi_longitude": "-97.5548794",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-236-0416",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-e7e8-71d5-8c9c-01335afc8775.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-e7e8-71d5-8c9c-01335afc8775",
        "storage_key": "property/6767906449165643/019d2709-e7e8-71d5-8c9c-01335afc8775.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJv3We_RoRsocRo0uc9ud0B-U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_d99e08cf-05a2-4fe8-835e-4af1be495d58",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "custom",
      "poi_name": "Tamashii Ramen House",
      "poi_type": "Restaurants",
      "poi_address": "321 NW 8th St, Oklahoma City, OK 73102, USA",
      "poi_short_description": "Casual, modern eatery featuring a variety of ramen noodle soups, plus fried rice.",
      "poi_long_description": "People say this ramen restaurant serves delicious Miso Butter Corn Ramen, Garlic Fried Rice, and other authentic Japanese dishes. They highlight the generous portions, reasonable prices, and the cozy, inviting atmosphere. They also like the attentive and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-b23d-701a-a749-cc15c0074586.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b23d-701a-a749-cc15c0074586",
        "storage_key": "property/6767906449165643/019d2709-b23d-701a-a749-cc15c0074586.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://tamashiiokc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6488468976857464375&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tamashii-ramen-house",
      "poi_latitude": "35.476337",
      "poi_longitude": "-97.51872",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-825-4532",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-e7e8-71d5-8c9c-01335afc8775.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-e7e8-71d5-8c9c-01335afc8775",
        "storage_key": "property/6767906449165643/019d2709-e7e8-71d5-8c9c-01335afc8775.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJM8u4mDEXsocRNz67NSisC1o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "ramen_restaurant"
    },
    {
      "id": "custom_7ec39ffd-3b60-4be8-9f75-e2c15177f8ac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "custom",
      "poi_name": "Harvey Bakery & Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "301 NW 13th St Suite 100, Oklahoma City, OK 73103, USA",
      "poi_short_description": "Popular bakery featuring house-baked goods, as well as sandwiches, coffee and hot chocolate.",
      "poi_long_description": "People say this restaurant serves delicious sandwiches, pastries, and cinnamon rolls, and offers a variety of drinks, including coffee and lattes. They highlight the reasonable prices, the cozy and vibrant atmosphere, and the friendly and efficient service. They also like the spacious seating and the option to dine indoors or outdoors.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-b2aa-72ab-841e-c77270cf84bc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b2aa-72ab-841e-c77270cf84bc",
        "storage_key": "property/6767906449165643/019d2709-b2aa-72ab-841e-c77270cf84bc.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.theharveybakery.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6007953407654856939&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "harvey-bakery--kitchen",
      "poi_latitude": "35.4825463",
      "poi_longitude": "-97.5176032",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 405-898-8811",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-e7e8-71d5-8c9c-01335afc8775.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-e7e8-71d5-8c9c-01335afc8775",
        "storage_key": "property/6767906449165643/019d2709-e7e8-71d5-8c9c-01335afc8775.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLe2-WOsXsocR64hd8sqJYFM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_1f2fd5a8-2b83-4048-abb5-44ee4c130eda",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "custom",
      "poi_name": "The Jones Assembly",
      "poi_type": "Restaurants",
      "poi_address": "901 W Sheridan Ave, Oklahoma City, OK 73106, USA",
      "poi_short_description": "Spacious eatery combining a bar and concert venue, serving elevated American staples alongside craft beer and cocktails.",
      "poi_long_description": "People say this restaurant offers delicious appetizers, brunch, and entrees, including Nashville hot chicken, deviled eggs, and dips and spreads. They highlight the spacious and appealing atmosphere, with a large outdoor patio and live music, perfect for date night or a fun night out. They also like the friendly and attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-b252-7538-82db-45c6db9df11f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b252-7538-82db-45c6db9df11f",
        "storage_key": "property/6767906449165643/019d2709-b252-7538-82db-45c6db9df11f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.thejonesassembly.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=206338142797659122&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-jones-assembly",
      "poi_latitude": "35.4666469",
      "poi_longitude": "-97.5273857",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-212-2378",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-e7e8-71d5-8c9c-01335afc8775.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-e7e8-71d5-8c9c-01335afc8775",
        "storage_key": "property/6767906449165643/019d2709-e7e8-71d5-8c9c-01335afc8775.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJwcSZY9QQsocR8nsRmXIP3QI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_2f48f48e-40ab-4d52-94fa-22bb205fddf5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "custom",
      "poi_name": "Cafe Kacao",
      "poi_type": "Restaurants",
      "poi_address": "3325 N Classen Blvd, Oklahoma City, OK 73118, USA",
      "poi_short_description": "Breakfast-to-dinner menu of Guatemalan eats including breakfast burritos, in a trendy setting.",
      "poi_long_description": "People say this Guatemalan restaurant serves delicious and authentic dishes, including carne asada, chilaquiles, and French toast. They highlight the generous portions, flavorful food, and the beautiful presentation of the dishes. They also like the friendly staff and the vibrant, colorful atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-b6d3-730e-a520-dade4d1fc974.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b6d3-730e-a520-dade4d1fc974",
        "storage_key": "property/6767906449165643/019d2709-b6d3-730e-a520-dade4d1fc974.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.cafekacao.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4497070532078455595&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cafe-kacao",
      "poi_latitude": "35.5038943",
      "poi_longitude": "-97.5347616",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-357-9913",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-e7e8-71d5-8c9c-01335afc8775.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-e7e8-71d5-8c9c-01335afc8775",
        "storage_key": "property/6767906449165643/019d2709-e7e8-71d5-8c9c-01335afc8775.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJX1xxbagQsocRK8tpitLNaD4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_8a257210-f47f-4bd9-a56b-51b0ca9ce292",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "custom",
      "poi_name": "OKC Outlets",
      "poi_type": "Shopping & Retail",
      "poi_address": "7624 W Reno Ave Suite 380, Oklahoma City, OK 73127, USA",
      "poi_short_description": "Relaxed outdoor mall featuring more than 70 brand-name designer stores of shoes, clothing and more.",
      "poi_long_description": "People say this outlet mall offers a wide variety of stores and good deals. They also highlight the friendly staff and nice shopping experience.\n\nOther reviews mention the food court can have limited options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-b725-75f9-95b2-1eea1883acc5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b725-75f9-95b2-1eea1883acc5",
        "storage_key": "property/6767906449165643/019d2709-b725-75f9-95b2-1eea1883acc5.webp",
        "width": 960,
        "height": 540
      },
      "poi_business_url": "https://www.okcoutlets.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1773095145334850603&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "okc-outlets",
      "poi_latitude": "35.4625898",
      "poi_longitude": "-97.6473972",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-787-3700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-e855-7426-a2fe-38acc0dfb7a3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-e855-7426-a2fe-38acc0dfb7a3",
        "storage_key": "property/6767906449165643/019d2709-e855-7426-a2fe-38acc0dfb7a3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJdWyLw68PsocRK0Sn8qNMmxg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_24caf3f8-df34-4498-ae08-305df7716770",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "custom",
      "poi_name": "Feria Latina Supermarket",
      "poi_type": "Shopping & Retail",
      "poi_address": "4909 NW 23rd St, Oklahoma City, OK 73127, USA",
      "poi_short_description": "Latino grocery and food store featuring fresh produce and a bakery.",
      "poi_long_description": "People say this supermarket offers fresh produce and delicious bakery items. They also highlight the reasonable prices on marinated meats and the convenient on-site restaurant.\n\nOther reviews mention the parking can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-b76e-77ff-b521-ad6375bc56fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b76e-77ff-b521-ad6375bc56fa",
        "storage_key": "property/6767906449165643/019d2709-b76e-77ff-b521-ad6375bc56fa.webp",
        "width": 949,
        "height": 1265
      },
      "poi_business_url": "http://www.laferialatina.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7639629429527723566&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "feria-latina-supermarket",
      "poi_latitude": "35.4938889",
      "poi_longitude": "-97.6113889",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-606-4004",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-e7fe-730b-bc27-2ec2f0897d99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-e7fe-730b-bc27-2ec2f0897d99",
        "storage_key": "property/6767906449165643/019d2709-e7fe-730b-bc27-2ec2f0897d99.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJm6vpcQIQsocRLr6eWn1qBWo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_9fe424e0-0996-4b5d-8170-f0fa97810f22",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "custom",
      "poi_name": "WinCo Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "3535 NW 39th St, Oklahoma City, OK 73112, USA",
      "poi_short_description": "Fresh meat and produce alongside bulk bins, plus a deli counter.",
      "poi_long_description": "Shoppers say this grocery store offers a wide variety of bulk items, including coffee beans, spices, and baking supplies, as well as fresh produce, delicious sushi, and a great deli selection. They also highlight the low prices, friendly staff, and clean store.\n\nSome reviews mention the checkout lines can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-b7c8-7432-b794-5ef34e5c998e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-b7c8-7432-b794-5ef34e5c998e",
        "storage_key": "property/6767906449165643/019d2709-b7c8-7432-b794-5ef34e5c998e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://wincofoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=888982261208729925&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "winco-foods",
      "poi_latitude": "35.512444",
      "poi_longitude": "-97.5798107",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-832-5070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-e7fe-730b-bc27-2ec2f0897d99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-e7fe-730b-bc27-2ec2f0897d99",
        "storage_key": "property/6767906449165643/019d2709-e7fe-730b-bc27-2ec2f0897d99.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCahmuZoasocRRUn4EqhMVgw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_45125ab4-9afa-4bc3-ad3c-c7f796197407",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "custom",
      "poi_name": "Super Cao Nguyen",
      "poi_type": "Shopping & Retail",
      "poi_address": "2668 N Military Ave, Oklahoma City, OK 73106, USA",
      "poi_short_description": "Asian food market filled with seafood, meat, herbs, baked goods and produce.",
      "poi_long_description": "People say this Asian grocery store offers a wide variety of fresh produce, seafood, meats, noodles, snacks, and pantry items, as well as cookware and kitchen utensils. They highlight the good prices and the fun, diverse selection of products, including hard-to-find and authentic ingredients. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-bb72-72cc-b065-0fa190f71a43.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-bb72-72cc-b065-0fa190f71a43",
        "storage_key": "property/6767906449165643/019d2709-bb72-72cc-b065-0fa190f71a43.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.caonguyen.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13652186644586231733&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "super-cao-nguyen",
      "poi_latitude": "35.4958547",
      "poi_longitude": "-97.5309569",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 405-525-7650",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-e7fe-730b-bc27-2ec2f0897d99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-e7fe-730b-bc27-2ec2f0897d99",
        "storage_key": "property/6767906449165643/019d2709-e7fe-730b-bc27-2ec2f0897d99.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwz4GFK4QsocRtffkvWtPdr0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_28e6c4cd-0df2-40f1-b911-2eeb9ecd860b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "custom",
      "poi_name": "Chinatown Supermarket",
      "poi_type": "Shopping & Retail",
      "poi_address": "1228 NW 27th St, Oklahoma City, OK 73106, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this Asian grocery store offers a wide variety of fresh produce, meat, seafood, and snacks, including hard-to-find items. They also highlight the fair prices and the friendly, helpful staff.\n\nSome reviews mention the store can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-bc57-717b-8a35-5d64c9851b5e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-bc57-717b-8a35-5d64c9851b5e",
        "storage_key": "property/6767906449165643/019d2709-bc57-717b-8a35-5d64c9851b5e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.okchinatownsupermarket.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1207031092404117916&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chinatown-supermarket",
      "poi_latitude": "35.4972585",
      "poi_longitude": "-97.5337255",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 405-528-8188",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-e7fe-730b-bc27-2ec2f0897d99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-e7fe-730b-bc27-2ec2f0897d99",
        "storage_key": "property/6767906449165643/019d2709-e7fe-730b-bc27-2ec2f0897d99.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2cB9AK8QsocRnGGZJ2I8wBA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_5a7ecd27-64dc-4fb2-aba8-be6df50f16d4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "custom",
      "poi_name": "Oklahoma City Community College",
      "poi_type": "Education",
      "poi_address": "7777 S May Ave, Oklahoma City, OK 73159, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-bcdd-73c9-836f-8ff3b5482553.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-bcdd-73c9-836f-8ff3b5482553",
        "storage_key": "property/6767906449165643/019d2709-bcdd-73c9-836f-8ff3b5482553.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.occc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12663331797127596950&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oklahoma-city-community-college",
      "poi_latitude": "35.3880406",
      "poi_longitude": "-97.5699184",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-682-1611",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-e7e2-765c-83f2-3ed59e416cd2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-e7e2-765c-83f2-3ed59e416cd2",
        "storage_key": "property/6767906449165643/019d2709-e7e2-765c-83f2-3ed59e416cd2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJq1zRlkwSsocRlguzIC0xva8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_45e636aa-b9b3-4ee6-b13c-2d357a53fa17",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "custom",
      "poi_name": "Oklahoma City University",
      "poi_type": "Education",
      "poi_address": "2501 N Blackwelder Ave, Oklahoma City, OK 73106, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-bcba-7002-a62f-0cf1578380dc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-bcba-7002-a62f-0cf1578380dc",
        "storage_key": "property/6767906449165643/019d2709-bcba-7002-a62f-0cf1578380dc.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.okcu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=411899583880737593&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oklahoma-city-university",
      "poi_latitude": "35.495481",
      "poi_longitude": "-97.5410111",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 405-208-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-e7e2-765c-83f2-3ed59e416cd2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-e7e2-765c-83f2-3ed59e416cd2",
        "storage_key": "property/6767906449165643/019d2709-e7e2-765c-83f2-3ed59e416cd2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJe7zZY6MQsocRObNXPH1ctwU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_89f283e8-27a5-4716-8a83-c220bb4db93b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "custom",
      "poi_name": "Southern Nazarene University",
      "poi_type": "Education",
      "poi_address": "6729 NW 39th Expy, Bethany, OK 73008, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-c05c-70a8-829e-71ad2ac57e94.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-c05c-70a8-829e-71ad2ac57e94",
        "storage_key": "property/6767906449165643/019d2709-c05c-70a8-829e-71ad2ac57e94.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.snu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2990625230431240297&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "southern-nazarene-university",
      "poi_latitude": "35.5135594",
      "poi_longitude": "-97.6288124",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 405-789-6400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-e7e2-765c-83f2-3ed59e416cd2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-e7e2-765c-83f2-3ed59e416cd2",
        "storage_key": "property/6767906449165643/019d2709-e7e2-765c-83f2-3ed59e416cd2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJHYsS70IFsocRacAsVM3VgCk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_8a6d82f5-7ec2-4f81-a632-c7d5dc9a117e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "custom",
      "poi_name": "Oklahoma State University Oklahoma City",
      "poi_type": "Education",
      "poi_address": "900 N Portland Ave, Oklahoma City, OK 73107, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-c2e3-707c-a54e-15652732a9ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-c2e3-707c-a54e-15652732a9ca",
        "storage_key": "property/6767906449165643/019d2709-c2e3-707c-a54e-15652732a9ca.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.osuokc.edu/home/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5945726857955521834&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oklahoma-state-university-oklahoma-city",
      "poi_latitude": "35.4705492",
      "poi_longitude": "-97.5821887",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-947-4421",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-e7e2-765c-83f2-3ed59e416cd2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-e7e2-765c-83f2-3ed59e416cd2",
        "storage_key": "property/6767906449165643/019d2709-e7e2-765c-83f2-3ed59e416cd2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJGzr99UMQsocRKjXwUxN3g1I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_a3726a64-d72b-4eb4-8e36-cbb3742035fc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "custom",
      "poi_name": "Ronald J. Norick Downtown Library - Metropolitan Library System",
      "poi_type": "Education",
      "poi_address": "300 Park Ave, Oklahoma City, OK 73102, USA",
      "poi_short_description": "Clean, relaxing public library with a friendly staff and a children's selection.",
      "poi_long_description": "People say this public library has a beautiful building with a spacious layout and a great selection of books. They also highlight the friendly and helpful staff who are always willing to assist patrons in finding what they need.\n\nSome reviews mention the environment can be noisy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-c200-718b-9734-31c3cd679290.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-c200-718b-9734-31c3cd679290",
        "storage_key": "property/6767906449165643/019d2709-c200-718b-9734-31c3cd679290.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.metrolibrary.org/?utm_source=GMBlisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=12884098639718649149&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ronald-j-norick-downtown-library---metropolitan-library-system",
      "poi_latitude": "35.46851729999999",
      "poi_longitude": "-97.5186272",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-231-8650",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-e7e2-765c-83f2-3ed59e416cd2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-e7e2-765c-83f2-3ed59e416cd2",
        "storage_key": "property/6767906449165643/019d2709-e7e2-765c-83f2-3ed59e416cd2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJM_ivrS4XsocRPQ2GL3ODzbI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_4b2e3961-ab20-4602-8206-0b1b57d470c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "custom",
      "poi_name": "Paycom Center",
      "poi_type": "Entertainment",
      "poi_address": "100 W Reno Ave, Oklahoma City, OK 73102, USA",
      "poi_short_description": "Big, clean venue for concerts, shows and sporting events such as hockey, basketball, wrestling, and monster truck rallies, as well as featuring concessions.",
      "poi_long_description": "Fans say this arena hosts exciting Thunder games and popular concerts, and they praise the electric atmosphere. They also highlight the friendly and helpful staff, easy access to seating, and clean facilities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-c1a7-728c-81e2-67562abf2fe5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-c1a7-728c-81e2-67562abf2fe5",
        "storage_key": "property/6767906449165643/019d2709-c1a7-728c-81e2-67562abf2fe5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.paycomcenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11905088268860757061&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "paycom-center",
      "poi_latitude": "35.4634247",
      "poi_longitude": "-97.5151138",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-602-8700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-ebaa-7719-b458-097cc8c5b877.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-ebaa-7719-b458-097cc8c5b877",
        "storage_key": "property/6767906449165643/019d2709-ebaa-7719-b458-097cc8c5b877.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmW2-HCgXsocRRZQdZbReN6U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_bd11635b-b517-4603-a145-952ba080bab5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "custom",
      "poi_name": "Oklahoma City National Memorial & Museum",
      "poi_type": "Entertainment",
      "poi_address": "620 N Harvey Ave, Oklahoma City, OK 73102, USA",
      "poi_short_description": "A garden, pool & sculptural memorial commemorating victims of the 1995 Murrah Building bombing.",
      "poi_long_description": "Visitors say this memorial and museum offers a moving experience, honoring the lives lost in the 1995 Oklahoma City bombing. They also highlight the peaceful and serene atmosphere, with many finding it a place for quiet reflection and remembrance.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-c553-727e-b277-7a1db2bff7d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-c553-727e-b277-7a1db2bff7d6",
        "storage_key": "property/6767906449165643/019d2709-c553-727e-b277-7a1db2bff7d6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://memorialmuseum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4635276338053722639&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oklahoma-city-national-memorial--museum",
      "poi_latitude": "35.4731496",
      "poi_longitude": "-97.5170593",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-235-3313",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-ec02-76da-b2de-da915c177b6b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-ec02-76da-b2de-da915c177b6b",
        "storage_key": "property/6767906449165643/019d2709-ec02-76da-b2de-da915c177b6b.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJq81FLi4XsocRDzJ3TUXPU0A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_3a6833f8-0026-41ce-876d-c52caadf4ce9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "custom",
      "poi_name": "Hurricane Harbor Oklahoma City",
      "poi_type": "Entertainment",
      "poi_address": "3908 W Reno Ave, Oklahoma City, OK 73107, USA",
      "poi_short_description": "Water park with lazy rivers and wave pools for kids and adults offering a variety of slides for all ages.",
      "poi_long_description": "People say this water park offers a variety of slides, a wave pool, and a lazy river. They also highlight the friendly staff, the clean facilities, and the fun atmosphere.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-c72a-7088-8a7e-b563f689ac32.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-c72a-7088-8a7e-b563f689ac32",
        "storage_key": "property/6767906449165643/019d2709-c72a-7088-8a7e-b563f689ac32.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.sixflags.com/hurricaneharborokc",
      "poi_directions_map_url": "https://maps.google.com/?cid=554219685046233621&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hurricane-harbor-oklahoma-city",
      "poi_latitude": "35.4616121",
      "poi_longitude": "-97.5886688",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-943-9687",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-ebaa-7719-b458-097cc8c5b877.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-ebaa-7719-b458-097cc8c5b877",
        "storage_key": "property/6767906449165643/019d2709-ebaa-7719-b458-097cc8c5b877.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMa4rXNURsocRFaq1_t37sAc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "custom_94c05247-a8d0-4e15-ade5-12241bc86035",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "custom",
      "poi_name": "Oklahoma City Museum of Art",
      "poi_type": "Entertainment",
      "poi_address": "415 Couch Dr, Oklahoma City, OK 73102, USA",
      "poi_short_description": "Clean art destination with 3 levels exhibiting paintings, films and sculptures.",
      "poi_long_description": "People say this art museum offers stunning glass displays, beautiful artwork, and a great gift shop. They highlight the free admission on the second Sunday of the month and the tranquil, relaxing vibe. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-c756-72bf-91b8-6c543e563297.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-c756-72bf-91b8-6c543e563297",
        "storage_key": "property/6767906449165643/019d2709-c756-72bf-91b8-6c543e563297.webp",
        "width": 573,
        "height": 410
      },
      "poi_business_url": "http://www.okcmoa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9657734537123882826&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oklahoma-city-museum-of-art",
      "poi_latitude": "35.4695638",
      "poi_longitude": "-97.5205029",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-236-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-ec02-76da-b2de-da915c177b6b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-ec02-76da-b2de-da915c177b6b",
        "storage_key": "property/6767906449165643/019d2709-ec02-76da-b2de-da915c177b6b.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ__8_PiwXsocRSmdKhGQqB4Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_c7dad0eb-9110-4b38-bdfd-f100b0535fdf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "custom",
      "poi_name": "Chickasaw Bricktown Ballpark",
      "poi_type": "Entertainment",
      "poi_address": "2 S Mickey Mantle Dr, Oklahoma City, OK 73104, USA",
      "poi_short_description": "Kid-friendly ballpark featuring minor-league baseball plus various themed promotions.",
      "poi_long_description": "Fans say this ballpark offers a fun, family-friendly atmosphere with exciting baseball games, interactive entertainment, and incredible Friday night fireworks. They also highlight the clean facilities, great seats with a breeze, and plentiful food and drink options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-c836-74b4-8493-92f75d522602.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-c836-74b4-8493-92f75d522602",
        "storage_key": "property/6767906449165643/019d2709-c836-74b4-8493-92f75d522602.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.okcdodgers.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18040532731312389442&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chickasaw-bricktown-ballpark",
      "poi_latitude": "35.465199",
      "poi_longitude": "-97.507761",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-218-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-ebc3-771d-9cb5-6dbfc15cf7c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-ebc3-771d-9cb5-6dbfc15cf7c1",
        "storage_key": "property/6767906449165643/019d2709-ebc3-771d-9cb5-6dbfc15cf7c1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJV6DhxiAXsocRQr2usO_YXPo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_e3741487-03e5-4cb7-906a-42e2dbda800f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "custom",
      "poi_name": "VASA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "4106 S Western Ave, Oklahoma City, OK 73109, USA",
      "poi_short_description": "Chain fitness center with an indoor pool, a basketball court, a sauna, and a variety of group fitness classes.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including machines, free weights, cardio, basketball court, racketball, swimming pool, hot tub, and sauna, as well as group fitness classes like BodyPump, HIIT, and yoga. They also highlight the friendly and helpful staff, the clean facilities, and the well-maintained equipment.\n\nOther reviews mention the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-ca81-742a-a5e5-0c16bd877355.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-ca81-742a-a5e5-0c16bd877355",
        "storage_key": "property/6767906449165643/019d2709-ca81-742a-a5e5-0c16bd877355.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://vasafitness.com/locations/ok/oklahoma-city/?utm_medium=organic&utm_source=GMBlisting&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=801655575634150052&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "vasa-fitness",
      "poi_latitude": "35.4239616",
      "poi_longitude": "-97.5284652",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 405-992-0210",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-ebaa-7719-b458-097cc8c5b877.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-ebaa-7719-b458-097cc8c5b877",
        "storage_key": "property/6767906449165643/019d2709-ebaa-7719-b458-097cc8c5b877.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtbC5qVYRsocRpILiqX8NIAs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_a9a6e3a4-2e00-45b0-8590-f355b37d58cb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "custom",
      "poi_name": "Neel Veterinary Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "2700 N MacArthur Blvd, Oklahoma City, OK 73127, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-cbcb-750e-b457-29b047540943.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-cbcb-750e-b457-29b047540943",
        "storage_key": "property/6767906449165643/019d2709-cbcb-750e-b457-29b047540943.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://neel.vet/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4132737864806100553&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "neel-veterinary-hospital",
      "poi_latitude": "35.4972708",
      "poi_longitude": "-97.6183664",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-947-8387",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-ebaa-7719-b458-097cc8c5b877.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-ebaa-7719-b458-097cc8c5b877",
        "storage_key": "property/6767906449165643/019d2709-ebaa-7719-b458-097cc8c5b877.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYV66BPkPsocRSe6SHTFvWjk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_1ff9db75-0afe-4184-b3c4-32946d408dbf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2936 SW 59th St, Oklahoma City, OK 73119, USA",
      "poi_short_description": "Laid-back chain of fitness centers featuring exercise equipment, plus tanning beds and massage chairs. Friendly and helpful staff, too.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-cc72-760f-9251-bb6421424773.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-cc72-760f-9251-bb6421424773",
        "storage_key": "property/6767906449165643/019d2709-cc72-760f-9251-bb6421424773.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/oklahoma-city-sw-59th-st-ok?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=4408626453489026629&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "35.4043835",
      "poi_longitude": "-97.5671348",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-605-8150",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-ebaa-7719-b458-097cc8c5b877.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-ebaa-7719-b458-097cc8c5b877",
        "storage_key": "property/6767906449165643/019d2709-ebaa-7719-b458-097cc8c5b877.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPR93sNITsocRRYaay2aWLj0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_3c803a25-5808-465e-863c-dc8485cebce2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "custom",
      "poi_name": "Colaw Fitness of Oklahoma City Gyms",
      "poi_type": "Health and Wellness",
      "poi_address": "3645 NW 39th St, Oklahoma City, OK 73112, USA",
      "poi_short_description": "Positive gym, with exercise equipment, tanning beds and massage chairs – plus spiritual wellness.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, tanning beds, and massage chairs. They highlight the affordable membership options, clean facilities, and welcoming atmosphere. They also like the friendly, helpful, and professional staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-cce3-75e3-a377-ac3468fd4a6a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-cce3-75e3-a377-ac3468fd4a6a",
        "storage_key": "property/6767906449165643/019d2709-cce3-75e3-a377-ac3468fd4a6a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://colawfitness.com/gyms/oklahoma-city-ok/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8355987367554066829&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "colaw-fitness-of-oklahoma-city-gyms",
      "poi_latitude": "35.5128276",
      "poi_longitude": "-97.5823903",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-838-1644",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-ebaa-7719-b458-097cc8c5b877.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-ebaa-7719-b458-097cc8c5b877",
        "storage_key": "property/6767906449165643/019d2709-ebaa-7719-b458-097cc8c5b877.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX0nvVDcbsocRjSm2Jj1u9nM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_f064b12a-aaaf-45a5-aaf2-20c59b240bbc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "custom",
      "poi_name": "Edward L. Gaylord Downtown YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "1 NW 4th St, Oklahoma City, OK 73102, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a variety of equipment and opportunities to be involved with the community. They highlight the welcoming atmosphere and friendly staff. They also like the hot tub.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-cee3-70aa-a085-7c891bab0860.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-cee3-70aa-a085-7c891bab0860",
        "storage_key": "property/6767906449165643/019d2709-cee3-70aa-a085-7c891bab0860.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://ymcaokc.org/branches/edward-l-gaylord-downtown/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17672734702586732260&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "edward-l-gaylord-downtown-ymca",
      "poi_latitude": "35.472348",
      "poi_longitude": "-97.5131397",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-297-7700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-ebaa-7719-b458-097cc8c5b877.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-ebaa-7719-b458-097cc8c5b877",
        "storage_key": "property/6767906449165643/019d2709-ebaa-7719-b458-097cc8c5b877.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJewDDcyUXsocR5J5m7ZMqQvU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_389b5b11-3ae6-4ab7-aa9c-df53c83d6095",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "custom",
      "poi_name": "Bethany YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "3400 N Mueller Ave, Bethany, OK 73008, USA",
      "poi_short_description": "Chain fitness center offering amenities such as a pool, basketball courts, and water aerobics classes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-d10e-729a-bd92-1f7ce3da3f05.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-d10e-729a-bd92-1f7ce3da3f05",
        "storage_key": "property/6767906449165643/019d2709-d10e-729a-bd92-1f7ce3da3f05.webp",
        "width": 994,
        "height": 533
      },
      "poi_business_url": "https://ymcaokc.org/branches/bethany/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8306823524238509196&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bethany-ymca",
      "poi_latitude": "35.5051032",
      "poi_longitude": "-97.6316419",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 405-789-0231",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-ebaa-7719-b458-097cc8c5b877.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-ebaa-7719-b458-097cc8c5b877",
        "storage_key": "property/6767906449165643/019d2709-ebaa-7719-b458-097cc8c5b877.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9wBj710FsocRjEQY3vvDR3M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_694bde3a-534c-42c8-9049-2763cbe0787c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Health and Wellness",
      "poi_address": "6417 SW 3rd St, Oklahoma City, OK 73128, USA",
      "poi_short_description": "Retailer offering a variety of cosmetics, perfumes, and skin and hair care products, plus salon services.",
      "poi_long_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-d0a9-7180-aa1b-ac4b78174558.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-d0a9-7180-aa1b-ac4b78174558",
        "storage_key": "property/6767906449165643/019d2709-d0a9-7180-aa1b-ac4b78174558.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/oklahoma-city-ok-280",
      "poi_directions_map_url": "https://maps.google.com/?cid=17811436559343706250&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "35.4630453",
      "poi_longitude": "-97.6282705",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-491-6223",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-ebaa-7719-b458-097cc8c5b877.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-ebaa-7719-b458-097cc8c5b877",
        "storage_key": "property/6767906449165643/019d2709-ebaa-7719-b458-097cc8c5b877.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhy1t88kPsocRimAWgy7vLvc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_7e128118-04a8-4607-8def-1ca11fd1a283",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "custom",
      "poi_name": "University Health Club",
      "poi_type": "Health and Wellness",
      "poi_address": "1000 N Lincoln Blvd, Oklahoma City, OK 73104, USA",
      "poi_short_description": "Clean, modern center for weights, cardio and racquet sports, plus a rock wall.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-d196-77af-909b-ea119fe50b30.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-d196-77af-909b-ea119fe50b30",
        "storage_key": "property/6767906449165643/019d2709-d196-77af-909b-ea119fe50b30.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.ouhsc.edu/uhc/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11177606121982613964&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "university-health-club",
      "poi_latitude": "35.4772433",
      "poi_longitude": "-97.5009427",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-271-1650",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-ebaa-7719-b458-097cc8c5b877.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-ebaa-7719-b458-097cc8c5b877",
        "storage_key": "property/6767906449165643/019d2709-ebaa-7719-b458-097cc8c5b877.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLz1hpRcXsocRzFkB5IvVHps",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_ef2c66ac-9147-4919-b815-93e8f804902e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "custom",
      "poi_name": "INTEGRIS Health Baptist Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "3300 Northwest Expy, Oklahoma City, OK 73112, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-d4ef-75fe-bd82-75b55792518a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-d4ef-75fe-bd82-75b55792518a",
        "storage_key": "property/6767906449165643/019d2709-d4ef-75fe-bd82-75b55792518a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://baptist.integrisok.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10369483754313068495&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "integris-health-baptist-medical-center",
      "poi_latitude": "35.5290386",
      "poi_longitude": "-97.5764421",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-949-3011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-ec33-7118-8dee-0942e5555b97.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-ec33-7118-8dee-0942e5555b97",
        "storage_key": "property/6767906449165643/019d2709-ec33-7118-8dee-0942e5555b97.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJLX5SM_IasocRz68D4IjO548",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_0a51d99b-31a4-4f95-8a89-b6014ce5ecff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "custom",
      "poi_name": "OU Health University of Oklahoma Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "700 NE 13th St, Oklahoma City, OK 73104, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-d52f-7079-a9da-5922decd9506.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-d52f-7079-a9da-5922decd9506",
        "storage_key": "property/6767906449165643/019d2709-d52f-7079-a9da-5922decd9506.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ouhealth.com/find-a-location/ou-health-university-of-oklahoma-medical-center/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13319687687583781516&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ou-health-university-of-oklahoma-medical-center",
      "poi_latitude": "35.4801296",
      "poi_longitude": "-97.4967819",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 405-271-4700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-ec33-7118-8dee-0942e5555b97.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-ec33-7118-8dee-0942e5555b97",
        "storage_key": "property/6767906449165643/019d2709-ec33-7118-8dee-0942e5555b97.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-ePGKSAXsocRjFKTkWEJ2bg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_0d806c69-78c5-42f6-974d-3041686b958c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "custom",
      "poi_name": "Scissortail Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "300 SW 7th St, Oklahoma City, OK 73109, USA",
      "poi_short_description": "Sprawling green area featuring playgrounds, ponds and food trucks, plus paddle-boat rentals.",
      "poi_long_description": "People say this park offers a variety of activities, including walking trails, a splash pad, a playground, and a ninja course. They highlight the beautiful landscaping, flowers, and views, as well as the fun and family-friendly vibe. They also like the free parking and the availability of food trucks and a farmers market.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-d597-77a1-bbf8-10ffefb4c159.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-d597-77a1-bbf8-10ffefb4c159",
        "storage_key": "property/6767906449165643/019d2709-d597-77a1-bbf8-10ffefb4c159.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://scissortailpark.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2532545101640635246&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "scissortail-park",
      "poi_latitude": "35.4596348",
      "poi_longitude": "-97.5176865",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-445-6277",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-ef61-704a-85c4-faca8edfc915.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-ef61-704a-85c4-faca8edfc915",
        "storage_key": "property/6767906449165643/019d2709-ef61-704a-85c4-faca8edfc915.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5fS8K30XsocRbhPyGFpoJSM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_243b2752-c92f-4e57-a2ce-49fc0b841f7a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "custom",
      "poi_name": "Myriad Botanical Gardens",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "301 W Reno Ave, Oklahoma City, OK 73102, USA",
      "poi_short_description": "Free 15-acre downtown botanical garden featuring seasonal activities, a carousel, and a dog park.",
      "poi_long_description": "People say this botanical garden offers a wide variety of plants, including tropical plants, orchids, and tulips, and features a conservatory, greenhouse, and walking paths. They highlight the beautiful and peaceful atmosphere, perfect for relaxing and taking photos, and the family-friendly amenities, such as a playground, splash pad, and carousel. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-d6a9-77c5-905a-b29b1af2e24c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-d6a9-77c5-905a-b29b1af2e24c",
        "storage_key": "property/6767906449165643/019d2709-d6a9-77c5-905a-b29b1af2e24c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.myriadgardens.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10363530004578021372&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "myriad-botanical-gardens",
      "poi_latitude": "35.46533110000001",
      "poi_longitude": "-97.5179073",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-445-7080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-ef61-704a-85c4-faca8edfc915.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-ef61-704a-85c4-faca8edfc915",
        "storage_key": "property/6767906449165643/019d2709-ef61-704a-85c4-faca8edfc915.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJA05XnykXsocR_K_5faGn0o8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_cc561d10-dc44-4d2b-9864-a98f3cb1e2d0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "custom",
      "poi_name": "Will Rogers Gardens",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3400 NW 36th St, Oklahoma City, OK 73112, USA",
      "poi_short_description": "Colorful arboretum featuring disc golf, tennis courts, a greenhouse and picnic sites.",
      "poi_long_description": "People say this botanical garden offers beautiful and well-maintained flower beds with a great variety of plants and flowers. They highlight the free entry and the well-labeled trees, plants, and flowers. They also like the beautiful setting for weddings and quinceañeras.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-daac-76b8-ac21-c9f1ac4369f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-daac-76b8-ac21-c9f1ac4369f2",
        "storage_key": "property/6767906449165643/019d2709-daac-76b8-ac21-c9f1ac4369f2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.okc.gov/departments/parks-recreation/will-rogers-gardens",
      "poi_directions_map_url": "https://maps.google.com/?cid=7664107588336218919&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "will-rogers-gardens",
      "poi_latitude": "35.5069148",
      "poi_longitude": "-97.5770745",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-297-1394",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-ef61-704a-85c4-faca8edfc915.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-ef61-704a-85c4-faca8edfc915",
        "storage_key": "property/6767906449165643/019d2709-ef61-704a-85c4-faca8edfc915.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1YeiZYMasocRJ_Mn0z5hXGo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_0c0bc033-457a-453d-bfa4-b91035bed73d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "custom",
      "poi_name": "Bricktown River Walk Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "400 E Reno Ave, Oklahoma City, OK 73104, USA",
      "poi_short_description": "Relaxed waterway area surrounded by restaurants and shops, with boat rides and a mini-golf course.",
      "poi_long_description": "Visitors say this park offers a relaxing boat ride, beautiful statues, and a scenic river walk with shops and restaurants. They also highlight the informative and enjoyable boat tour, the well-maintained walking trails, and the vibrant atmosphere, especially at night.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-d9f0-724d-b969-9c4e057afd83.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-d9f0-724d-b969-9c4e057afd83",
        "storage_key": "property/6767906449165643/019d2709-d9f0-724d-b969-9c4e057afd83.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://welcometobricktown.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14979120011152276064&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bricktown-river-walk-park",
      "poi_latitude": "35.4620033",
      "poi_longitude": "-97.5054353",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-235-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-ef61-704a-85c4-faca8edfc915.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-ef61-704a-85c4-faca8edfc915",
        "storage_key": "property/6767906449165643/019d2709-ef61-704a-85c4-faca8edfc915.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJqfsyU98WsocRYDqtkEmG4M8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_51e3bf3f-0c9a-4fc4-8437-3c7b1f11c1c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "custom",
      "poi_name": "Overholser Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9398-9000 S Overholser Rd, Oklahoma City, OK 73127, USA",
      "poi_short_description": "Peaceful park, lake and dam venue for walking, skating and biking.",
      "poi_long_description": "People say this park offers bike riding, fishing, kayaking, and walking trails. They highlight the relaxing and calm vibe, and the scenic views of the dam and lake. They also like the historic structure and the opportunity to walk across the dam.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-da35-716b-aea3-8f30e18671c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-da35-716b-aea3-8f30e18671c3",
        "storage_key": "property/6767906449165643/019d2709-da35-716b-aea3-8f30e18671c3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.okc.gov/Home/Components/FacilityDirectory/FacilityDirectory/224/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13345590610054369473&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "overholser-park",
      "poi_latitude": "35.4843833",
      "poi_longitude": "-97.6681182",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 405-297-2756",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-ef61-704a-85c4-faca8edfc915.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-ef61-704a-85c4-faca8edfc915",
        "storage_key": "property/6767906449165643/019d2709-ef61-704a-85c4-faca8edfc915.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6SWxWJkFsocRwVAUrvMPNbk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_59d1066e-8f66-4990-988d-7c1b3311c065",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "custom",
      "poi_name": "Will Rogers International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "7100 Terminal Dr, Oklahoma City, OK 73159, USA",
      "poi_short_description": "Oklahoma City-area airport featuring art & an outdoor garden with a bronze statue of its namesake.",
      "poi_long_description": "People say this airport is small and easy to navigate, with clear signage and quick access to car rentals. They also highlight the clean restrooms, friendly staff, and efficient security process.\n\nOther reviews mention the food options can be limited.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-dbf5-73d9-9a53-19f2ecff37ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-dbf5-73d9-9a53-19f2ecff37ac",
        "storage_key": "property/6767906449165643/019d2709-dbf5-73d9-9a53-19f2ecff37ac.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.flyokc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14888269631623114364&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "will-rogers-international-airport",
      "poi_latitude": "35.3888421",
      "poi_longitude": "-97.6001183",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-316-3200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-ef65-7240-a5e9-2a5cf6aea79c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-ef65-7240-a5e9-2a5cf6aea79c",
        "storage_key": "property/6767906449165643/019d2709-ef65-7240-a5e9-2a5cf6aea79c.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3X8qew0SsocRfK4hOVnCnc4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_5754ed4e-cd49-4961-aa27-b45de51fffe9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "custom",
      "poi_name": "Balon Corporation",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3245 S Hattie Ave, Oklahoma City, OK 73129, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-df08-77a4-8bb9-e9fc9009724d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-df08-77a4-8bb9-e9fc9009724d",
        "storage_key": "property/6767906449165643/019d2709-df08-77a4-8bb9-e9fc9009724d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.balon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3475131748365701705&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "balon-corporation",
      "poi_latitude": "35.4316418",
      "poi_longitude": "-97.4884057",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-677-3321",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-ebaa-7719-b458-097cc8c5b877.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-ebaa-7719-b458-097cc8c5b877",
        "storage_key": "property/6767906449165643/019d2709-ebaa-7719-b458-097cc8c5b877.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMQubgo8WsocRSRIFweklOjA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_b501391f-c9c7-4d15-92bb-c77dc49b4964",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "custom",
      "poi_name": "Hobby Lobby Transportation Offices",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7210-A SW 29th St, Oklahoma City, OK 73179, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-df08-77a4-8bb9-e4d70e47dee7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-df08-77a4-8bb9-e4d70e47dee7",
        "storage_key": "property/6767906449165643/019d2709-df08-77a4-8bb9-e4d70e47dee7.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://careers.hobbylobby.com/current-openings/distribution",
      "poi_directions_map_url": "https://maps.google.com/?cid=13971354854011465596&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hobby-lobby-transportation-offices",
      "poi_latitude": "35.4342047",
      "poi_longitude": "-97.6392657",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-745-1100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-ebaa-7719-b458-097cc8c5b877.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-ebaa-7719-b458-097cc8c5b877",
        "storage_key": "property/6767906449165643/019d2709-ebaa-7719-b458-097cc8c5b877.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJD2RzAswPsocRfG9IYDc55ME",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_cef10a33-c066-4d36-bb25-43bfcc53750c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "custom",
      "poi_name": "7725 Connect",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7725 W Reno Ave, Oklahoma City, OK 73127, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-df47-7379-9910-12473b6266da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-df47-7379-9910-12473b6266da",
        "storage_key": "property/6767906449165643/019d2709-df47-7379-9910-12473b6266da.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://7725connect.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7415117686874367476&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "7725-connect",
      "poi_latitude": "35.4651921",
      "poi_longitude": "-97.6493758",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-232-3242",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-ebaa-7719-b458-097cc8c5b877.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-ebaa-7719-b458-097cc8c5b877",
        "storage_key": "property/6767906449165643/019d2709-ebaa-7719-b458-097cc8c5b877.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT4bmHaYPsocR9OXczT_K52Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_606e2353-3db0-4526-b872-eb7b012213de",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "custom",
      "poi_name": "CACI",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7725 W Reno Ave, Oklahoma City, OK 73127, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-e059-71ec-a0d4-1c176aa93182.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-e059-71ec-a0d4-1c176aa93182",
        "storage_key": "property/6767906449165643/019d2709-e059-71ec-a0d4-1c176aa93182.webp",
        "width": 961,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=822969494413870097&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "caci",
      "poi_latitude": "35.4653077",
      "poi_longitude": "-97.6494573",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-ebaa-7719-b458-097cc8c5b877.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-ebaa-7719-b458-097cc8c5b877",
        "storage_key": "property/6767906449165643/019d2709-ebaa-7719-b458-097cc8c5b877.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJw22o8XEPsocREYSFF2XGaws",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_42d46d0d-9aa4-4e5a-92eb-8d7208df262a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "custom",
      "poi_name": "Bob Moore Auto Group",
      "poi_type": "Major Employers & Offices",
      "poi_address": "700 NW 5th St, Oklahoma City, OK 73102, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-e3df-72b8-b3e1-c5a3f6aa93fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-e3df-72b8-b3e1-c5a3f6aa93fa",
        "storage_key": "property/6767906449165643/019d2709-e3df-72b8-b3e1-c5a3f6aa93fa.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.bobmoore.com/?utm_source=google&utm_medium=organic&utm_campaign=googlemybusiness",
      "poi_directions_map_url": "https://maps.google.com/?cid=8474505470412563466&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bob-moore-auto-group",
      "poi_latitude": "35.4728595",
      "poi_longitude": "-97.5247761",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-605-2350",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d2709-ebaa-7719-b458-097cc8c5b877.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-ebaa-7719-b458-097cc8c5b877",
        "storage_key": "property/6767906449165643/019d2709-ebaa-7719-b458-097cc8c5b877.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmQQl1igXsocRCqQLU9N9m3U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_f336c05d-141a-4bc2-b69f-c6c2d7157bfe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "custom",
      "poi_name": "Emerson South Mid-High School",
      "poi_type": "Education",
      "poi_address": "1401 Johnston Dr, Oklahoma City, OK 73119, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.okcps.org/EmersonSouth",
      "poi_directions_map_url": "https://maps.google.com/?cid=18190673210135449295&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "emerson-south-mid-high-school",
      "poi_latitude": "35.4258383",
      "poi_longitude": "-97.5427281",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-587-7980",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019cfb4d-3f96-74ab-a8bc-f19534ec8a62.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-3f96-74ab-a8bc-f19534ec8a62",
        "storage_key": "property/6767906449165643/019cfb4d-3f96-74ab-a8bc-f19534ec8a62.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJp_14qkIRsocRz45WA-hAcvw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_17ab159d-2883-470a-bb5f-69c98c507c29",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "custom",
      "poi_name": "U.S. Grant High School",
      "poi_type": "Education",
      "poi_address": "5016 S Pennsylvania Ave, Oklahoma City, OK 73119, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d7913-bedf-76ea-a668-10f519f65884.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-bedf-76ea-a668-10f519f65884",
        "storage_key": "property/6767906449165643/019d7913-bedf-76ea-a668-10f519f65884.webp",
        "width": 622,
        "height": 1280
      },
      "poi_business_url": "http://www.okcps.org/Domain/78",
      "poi_directions_map_url": "https://maps.google.com/?cid=12960320506949649165&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "u-s-grant-high-school",
      "poi_latitude": "35.4147992",
      "poi_longitude": "-97.5451391",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-587-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019cfb4d-3f96-74ab-a8bc-f19534ec8a62.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-3f96-74ab-a8bc-f19534ec8a62",
        "storage_key": "property/6767906449165643/019cfb4d-3f96-74ab-a8bc-f19534ec8a62.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_WrXuN8TsocRDcPxl9VO3LM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_dac3963f-1df4-453b-9062-9153164f4a2f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "custom",
      "poi_name": "Charleston's Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "2000 S Meridian Ave, Oklahoma City, OK 73108, USA",
      "poi_short_description": "Relaxed hangout serving classic pub fare, such as burgers, ribs & tenders, plus wine & cocktails.",
      "poi_long_description": "People say this restaurant serves delicious prime rib, pork chops, and chicken fried steak, as well as dynamite shrimp and key lime pie. They highlight the generous portions, the melt-in-your-mouth croissants, and the flavorful, smoky martinis. They also like the friendly and attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d7913-c3bc-75ea-a65d-25ebd1e8c715.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-c3bc-75ea-a65d-25ebd1e8c715",
        "storage_key": "property/6767906449165643/019d7913-c3bc-75ea-a65d-25ebd1e8c715.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://charlestons.com/locations/charlestons-okc-meridian/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9995273657061437338&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "charleston-s-restaurant",
      "poi_latitude": "35.44460160000001",
      "poi_longitude": "-97.6004516",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 405-681-6686",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019cfb4d-3f9a-7546-85b1-d668a9161ab0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-3f9a-7546-85b1-d668a9161ab0",
        "storage_key": "property/6767906449165643/019cfb4d-3f9a-7546-85b1-d668a9161ab0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZWU_LMURsocRmm_3EW9Ytoo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_24df254b-fc7e-4d31-ac20-ae26792ddbd4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "custom",
      "poi_name": "San Marcos Mexican Restaurant (S. Meridian)",
      "poi_type": "Restaurants",
      "poi_address": "1732 S Meridian Ave, Oklahoma City, OK 73108, USA",
      "poi_short_description": "Casual, family-owned eatery offering tamales, burritos & other Mexican food, plus beer & margaritas.",
      "poi_long_description": "Diners say this Mexican restaurant serves up delicious Burrito Locos, quesadillas, tacos, and chips with salsa and queso. They also highlight the friendly and attentive service, quick service, and affordable prices.\n\nSome reviews mention the food can be bland.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d7913-bd71-71bb-b9e7-9a4910b5a574.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-bd71-71bb-b9e7-9a4910b5a574",
        "storage_key": "property/6767906449165643/019d7913-bd71-71bb-b9e7-9a4910b5a574.webp",
        "width": 989,
        "height": 556
      },
      "poi_business_url": "http://www.oksanmarcos.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16479758147539973507&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "san-marcos-mexican-restaurant-s-meridian",
      "poi_latitude": "35.4467659",
      "poi_longitude": "-97.600438",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 405-778-8080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019cfb4d-3f9a-7546-85b1-d668a9161ab0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-3f9a-7546-85b1-d668a9161ab0",
        "storage_key": "property/6767906449165643/019cfb4d-3f9a-7546-85b1-d668a9161ab0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJde8MVcURsocRgzV4wLjcs-Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_2743c726-3fd0-4ecd-87e5-dfee734f741b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "custom",
      "poi_name": "Pickles Express Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "4517 SW 29th St, Oklahoma City, OK 73179, USA",
      "poi_short_description": "American comfort food such as chicken fried steak and catfish served in a casual space.",
      "poi_long_description": "People say this American restaurant serves delicious breakfast and comfort food, including chicken fried steak, biscuits and gravy, and burgers. They highlight the fair prices, generous portions, and fun, welcoming atmosphere. They also like the friendly and attentive service provided by the waitresses.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d7913-c0c9-7327-b948-65deef5a14cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-c0c9-7327-b948-65deef5a14cc",
        "storage_key": "property/6767906449165643/019d7913-c0c9-7327-b948-65deef5a14cc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://order.online/business/pickles-express-inc-12906957",
      "poi_directions_map_url": "https://maps.google.com/?cid=6269553094409836559&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "pickles-express-restaurant",
      "poi_latitude": "35.4354661",
      "poi_longitude": "-97.6019267",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 405-600-6272",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019cfb4d-3f9a-7546-85b1-d668a9161ab0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-3f9a-7546-85b1-d668a9161ab0",
        "storage_key": "property/6767906449165643/019cfb4d-3f9a-7546-85b1-d668a9161ab0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJYfDZ8ucRsocRD9i_ZFLtAVc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_4f59a07e-a9aa-4900-9efb-2a0846d9656f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "custom",
      "poi_name": "Tacoville",
      "poi_type": "Restaurants",
      "poi_address": "3502 Newcastle Rd, Oklahoma City, OK 73119, USA",
      "poi_short_description": "No-nonsense counter-serve joint serving up Mexican favorites like tacos & burritos since 1967.",
      "poi_long_description": "People say this Mexican restaurant serves delicious burritos, tacos, and nachos, and is known for its homemade hot sauce. They highlight the affordable prices and the fast, efficient service. They also like the casual, dive-like atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d7913-c457-7066-878d-51020627dd95.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-c457-7066-878d-51020627dd95",
        "storage_key": "property/6767906449165643/019d7913-c457-7066-878d-51020627dd95.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.facebook.com/Tacoville-108063339235811/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4500553165106390821&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tacoville",
      "poi_latitude": "35.4345619",
      "poi_longitude": "-97.5798846",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-681-0661",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019cfb4d-3f9a-7546-85b1-d668a9161ab0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-3f9a-7546-85b1-d668a9161ab0",
        "storage_key": "property/6767906449165643/019cfb4d-3f9a-7546-85b1-d668a9161ab0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJmVz4m5cRsocRJSftOkItdT4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_b2c174ef-65ae-4570-981c-aa7cebb1a544",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "custom",
      "poi_name": "El Patio",
      "poi_type": "Restaurants",
      "poi_address": "3421 SW 29th St, Oklahoma City, OK 73119, USA",
      "poi_short_description": "Authentic, no-frills shop offering pork, chicken and cheese tamales to go or for casual eats.",
      "poi_long_description": "People say this Mexican restaurant serves delicious pork, chicken, and cheese tamales. They highlight the generous portions, flavorful fillings, and moist masa, and like the affordable prices. They also mention the tamales are authentic and homemade.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d7913-c5a1-74d8-9250-c053cd54dc3d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-c5a1-74d8-9250-c053cd54dc3d",
        "storage_key": "property/6767906449165643/019d7913-c5a1-74d8-9250-c053cd54dc3d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://el-patio.shop/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17721131116909142538&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "el-patio",
      "poi_latitude": "35.4353747",
      "poi_longitude": "-97.5768516",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-605-1800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019cfb4d-3f9a-7546-85b1-d668a9161ab0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-3f9a-7546-85b1-d668a9161ab0",
        "storage_key": "property/6767906449165643/019cfb4d-3f9a-7546-85b1-d668a9161ab0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_bpHhpcRsocRCqJ9Odwa7vU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_13490caf-ab26-452f-a6e8-cb75b1cdaea2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "custom",
      "poi_name": "Golden Palace",
      "poi_type": "Restaurants",
      "poi_address": "1500 S Meridian Ave, Oklahoma City, OK 73108, USA",
      "poi_short_description": "Extensive buffet with Chinese & Vietnamese items plus Mongolian BBQ in an informal setting.",
      "poi_long_description": "People say this Vietnamese restaurant offers a wide variety of dishes, including Mongolian BBQ, pho, and sushi, and the food is often fresh and hot.\n\nOther reviews mention the food can be overcooked and the service can be impolite.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d7913-cd08-701e-a2a9-488d5de92909.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-cd08-701e-a2a9-488d5de92909",
        "storage_key": "property/6767906449165643/019d7913-cd08-701e-a2a9-488d5de92909.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=9984306117734480132&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "golden-palace",
      "poi_latitude": "35.448602",
      "poi_longitude": "-97.600376",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 405-686-1511",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019cfb4d-3f9a-7546-85b1-d668a9161ab0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-3f9a-7546-85b1-d668a9161ab0",
        "storage_key": "property/6767906449165643/019cfb4d-3f9a-7546-85b1-d668a9161ab0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJqTRJ388RsocRBLlS1INhj4o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "vietnamese_restaurant"
    },
    {
      "id": "custom_a869c71d-705b-4ed1-a336-dbcd8fbcdadd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "custom",
      "poi_name": "Chili's Grill & Bar",
      "poi_type": "Restaurants",
      "poi_address": "1704 S Meridian Ave, Oklahoma City, OK 73108, USA",
      "poi_short_description": "Family-friendly chain serving classic Tex-Mex & American fare in a Southwestern-style setting.",
      "poi_long_description": "People say this restaurant serves delicious baby back ribs, salmon, and burgers. They also highlight the good service and the fun, welcoming atmosphere.\n\nOther reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d7913-cfb6-725a-8157-f0c39e29ab89.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-cfb6-725a-8157-f0c39e29ab89",
        "storage_key": "property/6767906449165643/019d7913-cfb6-725a-8157-f0c39e29ab89.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.chilis.com/locations/us/oklahoma/oklahoma-city/okc-i-meridian?utm_source=google&utm_medium=local&utm_campaign=Chilis",
      "poi_directions_map_url": "https://maps.google.com/?cid=9315630392756553875&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "chili-s-grill-bar",
      "poi_latitude": "35.447538",
      "poi_longitude": "-97.600584",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 405-682-2453",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019cfb4d-3f9a-7546-85b1-d668a9161ab0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-3f9a-7546-85b1-d668a9161ab0",
        "storage_key": "property/6767906449165643/019cfb4d-3f9a-7546-85b1-d668a9161ab0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJL3faBNARsocRk0gWY3zER4E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_d64d263e-5dfb-4089-8a3a-c1d12582d2fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "custom",
      "poi_name": "Boot Barn",
      "poi_type": "Restaurants",
      "poi_address": "812 S Meridian Ave, Oklahoma City, OK 73108, USA",
      "poi_short_description": "Retail chain with a variety of Western & work-related apparel, shoes & accessories, plus gifts.",
      "poi_long_description": "People say this boot store offers a wide selection of boots, workwear, and western apparel. They also highlight the friendly and helpful service, and the reasonable prices.\n\nOther reviews mention the service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d7913-cff2-710e-a3e2-457abef48897.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-cff2-710e-a3e2-457abef48897",
        "storage_key": "property/6767906449165643/019d7913-cff2-710e-a3e2-457abef48897.webp",
        "width": 1088,
        "height": 611
      },
      "poi_business_url": "https://www.bootbarn.com/stores?StoreID=0302",
      "poi_directions_map_url": "https://maps.google.com/?cid=5294982221274977692&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "boot-barn",
      "poi_latitude": "35.4561967",
      "poi_longitude": "-97.5996441",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 405-947-6831",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019cfb4d-4089-767f-b997-6dce5263ce36.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-4089-767f-b997-6dce5263ce36",
        "storage_key": "property/6767906449165643/019cfb4d-4089-767f-b997-6dce5263ce36.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJsR_XaM0RsocRnJUat0aOe0k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shoe_store"
    },
    {
      "id": "custom_ea0c58c1-6c4e-4ed1-b984-0fe7dd8e0ada",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "custom",
      "poi_name": "Walmart Neighborhood Market",
      "poi_type": "Restaurants",
      "poi_address": "6437 N MacArthur Blvd, Warr Acres, OK 73132, USA",
      "poi_short_description": "Discount retailer showcasing food and beverages, along with electronics and clothes.",
      "poi_long_description": "People say this grocery store offers a good selection of items and the staff is friendly and helpful.\n\nOther reviews mention the produce can be disappointing and the self-checkout can be problematic.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d7913-d57e-70bd-8b34-4092ad683abc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-d57e-70bd-8b34-4092ad683abc",
        "storage_key": "property/6767906449165643/019d7913-d57e-70bd-8b34-4092ad683abc.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.walmart.com/store/2875-warr-acres-ok/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=9552327240482331639&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "walmart-neighborhood-market",
      "poi_latitude": "35.5379401",
      "poi_longitude": "-97.6210951",
      "poi_miles_from_property": "9.5 mi",
      "poi_walking_minutes": "3 hours 32 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 405-495-1001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019cfb4d-3f8b-77ab-9eab-9433d981d129.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-3f8b-77ab-9eab-9433d981d129",
        "storage_key": "property/6767906449165643/019cfb4d-3f8b-77ab-9eab-9433d981d129.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3YYgNC8FsocR95s8ywOvkIQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_565e50a1-ad42-489e-b677-2289d26f2ce7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "custom",
      "poi_name": "The Criterion",
      "poi_type": "Entertainment",
      "poi_address": "500 E Sheridan Ave, Oklahoma City, OK 73104, USA",
      "poi_short_description": "false",
      "poi_long_description": "People say this live music venue offers great performances by talented artists. They also highlight the wonderful sound, intimate atmosphere, and helpful staff.\n\nOther reviews mention the drinks can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d7913-d7cc-7301-bc48-41160eca948d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-d7cc-7301-bc48-41160eca948d",
        "storage_key": "property/6767906449165643/019d7913-d7cc-7301-bc48-41160eca948d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://criterionokc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18241039864595162344&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-criterion",
      "poi_latitude": "35.4656372",
      "poi_longitude": "-97.5042887",
      "poi_miles_from_property": "6.8 mi",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-840-5500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019cfb4d-3fa6-753c-a6e3-b3451d6ce97b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-3fa6-753c-a6e3-b3451d6ce97b",
        "storage_key": "property/6767906449165643/019cfb4d-3fa6-753c-a6e3-b3451d6ce97b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN7DKNiAXsocR6CTvlhwxJf0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "custom_503268ec-bffc-41de-917e-f14bec49b641",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "custom",
      "poi_name": "Oklahoma State Fair Event",
      "poi_type": "Entertainment",
      "poi_address": "333 Gordon Cooper Blvd St, Oklahoma City, OK 73107, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d7913-d8c6-73eb-9241-cf5088114f1f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-d8c6-73eb-9241-cf5088114f1f",
        "storage_key": "property/6767906449165643/019d7913-d8c6-73eb-9241-cf5088114f1f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=3300697560003685631&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "oklahoma-state-fair-event",
      "poi_latitude": "35.470576",
      "poi_longitude": "-97.5735435",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-948-6700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019cfb4d-3fa6-753c-a6e3-b3451d6ce97b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-3fa6-753c-a6e3-b3451d6ce97b",
        "storage_key": "property/6767906449165643/019cfb4d-3fa6-753c-a6e3-b3451d6ce97b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJY5Ko6FkQsocR_6wEZ_Fuzi0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_981a63c7-df5a-44c6-9071-3e3da6359375",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "custom",
      "poi_name": "Will Rogers Business Park",
      "poi_type": "Entertainment",
      "poi_address": "7501 SW 29th St, Oklahoma City, OK 73128, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d7913-d942-77bb-8d30-8df21f361104.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-d942-77bb-8d30-8df21f361104",
        "storage_key": "property/6767906449165643/019d7913-d942-77bb-8d30-8df21f361104.webp",
        "width": 1280,
        "height": 857
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=9341802870049815721&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "will-rogers-business-park",
      "poi_latitude": "35.4390364",
      "poi_longitude": "-97.6487519",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-740-5062",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019cfb4d-3fa6-753c-a6e3-b3451d6ce97b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-3fa6-753c-a6e3-b3451d6ce97b",
        "storage_key": "property/6767906449165643/019cfb4d-3fa6-753c-a6e3-b3451d6ce97b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRYDwHVsOsocRqTwLHzfApIE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6bc2255e-9c7b-4404-9988-bbc7d9e073e3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "custom",
      "poi_name": "Tulsa Park",
      "poi_type": "Entertainment",
      "poi_address": "2500 S Tulsa Ave, Oklahoma City, OK 73108, USA",
      "poi_short_description": "Neighborhood park featuring a playground, a walking trail, and sports courts.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d7913-dd6c-70d0-a2ef-d01e35bf826d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-dd6c-70d0-a2ef-d01e35bf826d",
        "storage_key": "property/6767906449165643/019d7913-dd6c-70d0-a2ef-d01e35bf826d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=5173572299742703155&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tulsa-park",
      "poi_latitude": "35.44164",
      "poi_longitude": "-97.5933331",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-297-3882",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019cfb4d-3f8e-7297-b923-ae8c8a08c529.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-3f8e-7297-b923-ae8c8a08c529",
        "storage_key": "property/6767906449165643/019cfb4d-3f8e-7297-b923-ae8c8a08c529.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3Y2zM8ERsocRM-72iZg4zEc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_353a03a3-8616-40b1-8dde-180e0b3afb62",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "custom",
      "poi_name": "Centennial Land Run Monument",
      "poi_type": "Entertainment",
      "poi_address": "200 Centennial Ave, Oklahoma City, OK 73102, USA",
      "poi_short_description": "Huge bronze statue marking the opening of the land in Oklahoma Territory with the Land Run of 1889.",
      "poi_long_description": "People say this monument features a large, detailed series of bronze statues depicting the Land Run. They highlight the impressive scale and artistry, and the emotional and meaningful experience it provides. They also like the peaceful atmosphere and the opportunity for photos and historical exploration.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d7913-e4ba-779b-91b4-0c099329c811.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-e4ba-779b-91b4-0c099329c811",
        "storage_key": "property/6767906449165643/019d7913-e4ba-779b-91b4-0c099329c811.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.visitokc.com/listings/oklahoma-land-run-monument/467/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18279960551545149272&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "centennial-land-run-monument",
      "poi_latitude": "35.4611333",
      "poi_longitude": "-97.5051775",
      "poi_miles_from_property": "6.6 mi",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-297-8912",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d7913-f34b-72cb-a4ca-7d44228cb367.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7913-f34b-72cb-a4ca-7d44228cb367",
        "storage_key": "property/6767906449165643/019d7913-f34b-72cb-a4ca-7d44228cb367.webp",
        "width": 103,
        "height": 192
      },
      "poi_google_place_id": "ChIJW8Nyrd8WsocRWJcAL0V3r_0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "monument"
    },
    {
      "id": "custom_fcdf3cae-4e50-453e-9f72-a3f15c5a7450",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "custom",
      "poi_name": "Stockyards City Main Street",
      "poi_type": "Entertainment",
      "poi_address": "2401 Exchange Ave Suite D, Oklahoma City, OK 73108, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d7913-e321-74a2-af70-f5bb7fe09844.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-e321-74a2-af70-f5bb7fe09844",
        "storage_key": "property/6767906449165643/019d7913-e321-74a2-af70-f5bb7fe09844.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.stockyardscity.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13526817862722862240&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "stockyards-city-main-street",
      "poi_latitude": "35.4532302",
      "poi_longitude": "-97.5566911",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-235-7267",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019cfb4d-3fa6-753c-a6e3-b3451d6ce97b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-3fa6-753c-a6e3-b3451d6ce97b",
        "storage_key": "property/6767906449165643/019cfb4d-3fa6-753c-a6e3-b3451d6ce97b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2cdOABsRsocRoDwBkS3puLs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "custom_a6bf94e4-32bb-48da-9ef6-d0964c30ca63",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "custom",
      "poi_name": "Oklahoma River Cruises - Meridian Landing",
      "poi_type": "Entertainment",
      "poi_address": "4345 SW 15th St, Oklahoma City, OK 73108, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d7913-e67d-71f5-bef3-1a90b406a92c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-e67d-71f5-bef3-1a90b406a92c",
        "storage_key": "property/6767906449165643/019d7913-e67d-71f5-bef3-1a90b406a92c.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "https://www.embarkok.com/ferry/meridian-landing",
      "poi_directions_map_url": "https://maps.google.com/?cid=18353623273896235266&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "oklahoma-river-cruises-meridian-landing",
      "poi_latitude": "35.4479451",
      "poi_longitude": "-97.595415",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 405-702-7755",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019cfb4d-3fa6-753c-a6e3-b3451d6ce97b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-3fa6-753c-a6e3-b3451d6ce97b",
        "storage_key": "property/6767906449165643/019cfb4d-3fa6-753c-a6e3-b3451d6ce97b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJk-uSKcYRsocRAlHtPSArtf4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_b41f5e0b-d62a-4a47-8bbb-640a7c65c700",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "custom",
      "poi_name": "Oklahoma Sports Hall of Fame",
      "poi_type": "Entertainment",
      "poi_address": "20 S Mickey Mantle Dr, Oklahoma City, OK 73104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019d7913-e919-77f0-bf90-9f7083f3af4c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-e919-77f0-bf90-9f7083f3af4c",
        "storage_key": "property/6767906449165643/019d7913-e919-77f0-bf90-9f7083f3af4c.webp",
        "width": 1280,
        "height": 857
      },
      "poi_business_url": "http://www.oklahomasportshalloffame.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12562508795526603302&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "oklahoma-sports-hall-of-fame",
      "poi_latitude": "35.4656333",
      "poi_longitude": "-97.5084684",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-427-1400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019cfb4d-3f9b-7660-8aea-e38bf66ed910.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4d-3f9b-7660-8aea-e38bf66ed910",
        "storage_key": "property/6767906449165643/019cfb4d-3f9b-7660-8aea-e38bf66ed910.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJc9O0B94ZsocRJmIVxTD_Vq4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_26964e88-d0ba-4fc8-b25d-f86d0e019e06",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "custom",
      "poi_name": "Brewskeys Bar and Grill",
      "poi_type": "Restaurants",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "brewskeys-bar-and-grill",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5868be11-2ea5-4810-b5b0-abdda8eb26c7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "custom",
      "poi_name": "The Outlet Shoppes",
      "poi_type": "Restaurants",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "the-outlet-shoppes",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_5c5890ff3dd71bb3fa15030c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_719c98580687aafe1ed331fe",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_a23c8047237d313c9a73e968",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_2425b26ac8f8c7531514060c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_a68ddbdb5feff3fa8a3b24d4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    },
    {
      "id": "ec_82becdff7c2213218262ad6a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "custom_91dd90a9-959b-4f0f-8ac6-23227fb68d05",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "rating": "5.0",
      "name": "Sandra Crumpler",
      "text": "Fast, efficient and very friendly. What a pleasure to live in an apartment community where they really care about you and your occasional repairs. I'm amazed all the time how awesome it is to live here at Waters Edge!",
      "date": "2025-10-10",
      "title": ""
    },
    {
      "id": "custom_46d80bb6-3db6-4926-addb-39d0f2362673",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "rating": "5.0",
      "name": "Dropset24",
      "text": "I will be here for 3 years in October. I find it comfortable to live here. We are close to everything as to shopping, fishing , recreational areas, restaurants and beautiful atmosphere here at night with the view of the ponds at night as they illuminate with the lights all around . The staff is always helpful the maintenance team is awesome all around apartment complex they're all available to you as soon as possible if anything is needed.",
      "date": "2025-08-01",
      "title": ""
    },
    {
      "id": "custom_56988c24-7df6-4de8-93fa-2081a1b855b7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "rating": "5.0",
      "name": "Melissa Anderson",
      "text": "This property has a beautiful view! It is a quiet and peaceful place! The staff has been very helpful! We worked mostly with Sheree. I highly recommend this property! Close to highways,jobs and close to Oklahoma City.",
      "date": "2025-05-29",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_f1161715-3be1-476c-adcf-5fc8792a9919",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019cfb4d-d1e6-7681-a707-8fbf4a1a5c00.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360 virtual tour of apartment community common area with seating",
        "public_id": "019cfb4d-d1e6-7681-a707-8fbf4a1a5c00",
        "storage_key": "property/6767906449165643/019cfb4d-d1e6-7681-a707-8fbf4a1a5c00.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Waters Edge Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=5f6d631a70a7b90f5768c7a1&sourceId=1001"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019cf79e-7d06-74cf-8902-d9eae0b838a2",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "waters-edge-apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643"
    },
    {
      "lead_collector_id": "019cf79e-7d7a-75fb-ba22-8d48c839ca79",
      "lead_source": "LANDING_PAGE",
      "name": "waters-edge-apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "generator",
      "page_item_url": "apartments-with-pool-oklahoma-city",
      "search_query": "apartments with pool in Oklahoma City",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Oklahoma City",
      "h2_subtitle": "Discover top-tier apartments with a pool in the heart of Oklahoma City. Experience the perfect blend of comfort and convenience at Waters Edge Apartments.",
      "page_copy": "Dive into comfort at Waters Edge Apartments where our shimmering pool sets the stage for relaxation and leisure. Situated in the scenic part of Oklahoma City, Waters Edge offers not only a modern take on apartment living but also provides our residents access to excellent amenities. Our one and two-bedroom layouts are complemented by essential facilities like a fitness center, scenic walking trails, and a pet play area.<br>\nEnjoy serene waterfront views right from your doorstep and unwind in a smoke-free, cable-ready apartment that caters to all your lifestyle needs. Whether you’re basking by the pool or enjoying high-speed internet indoors, Waters Edge Apartments delivers a unique living experience. Schedule a tour and see why our apartments with a pool are the ideal choice for you in Oklahoma City.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019cfb4d-19dd-750a-9c05-70354c830050.webp",
      "featured_image_media": {
        "alt_text": "Living room and dining room with farmhouse decor.",
        "public_id": "019cfb4d-19dd-750a-9c05-70354c830050",
        "storage_key": "property/6767906449165643/019cfb4d-19dd-750a-9c05-70354c830050.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in Oklahoma City",
      "seo_description": "Find serene apartment living with a pool at Waters Edge in Oklahoma City. Enjoy modern amenities and spacious layouts. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-w-south-oklahoma-city",
      "search_query": "pet friendly apartments W South Oklahoma City",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments in W South OKC",
      "h2_subtitle": "Explore pet friendly apartments in the W South Oklahoma City area. Waters Edge Apartments offers a vibrant, pet-inclusive community with great amenities.",
      "page_copy": "At Waters Edge Apartments, we understand that pets are part of the family. Located conveniently in W South Oklahoma City, our pet friendly community provides a warm welcome to furry residents. With a dedicated pet play area and scenic walking trails, both you and your pet can enjoy the tranquility and outdoor activities offered by our waterfront living.<br> \nIn addition to our pet amenities, Waters Edge also features spacious one and two-bedroom layouts, a shimmering pool, and a fully equipped fitness center. Situated in a smoke-free environment, our apartments are cable ready and offer easy lake access. Join a community that appreciates your pets as much as you do—schedule a tour of Waters Edge Apartments in W South Oklahoma City today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019cfb4d-19dd-750a-9c05-70354c830050.webp",
      "featured_image_media": {
        "alt_text": "Living room and dining room with farmhouse decor.",
        "public_id": "019cfb4d-19dd-750a-9c05-70354c830050",
        "storage_key": "property/6767906449165643/019cfb4d-19dd-750a-9c05-70354c830050.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments in W South OKC",
      "seo_description": "Discover pet friendly apartments at Waters Edge in W South Oklahoma City, where your pets are as welcome as you are. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "generator",
      "page_item_url": "oklahoma-city-apartments-with-fitness-center",
      "search_query": "Oklahoma City apartments with fitness center",
      "category": "Amenity",
      "h1_title": "OKC Apartments with Fitness Center",
      "h2_subtitle": "Find Oklahoma City apartments with an on-site fitness center. Waters Edge Apartments offers modern amenities in a tranquil setting.",
      "page_copy": "For those seeking an active lifestyle in Oklahoma City, Waters Edge Apartments provides an exceptional solution with our state-of-the-art fitness center. Nestled in a serene waterfront location, our community offers you not only fitness facilities but also the tranquility of nature and the modern comforts of apartment living. \nIn addition to the fitness center, enjoy our shimmering pool, pet play area, and scenic walking trails. Our spacious one and two-bedroom layouts ensure you have all the comforts you desire, from high-speed internet to stunning lake access. Join a community that supports your lifestyle goals—schedule a visit to Waters Edge Apartments today and see why our fitness-centered amenities make us stand out in Oklahoma City.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019cfb4d-19dd-750a-9c05-70354c830050.webp",
      "featured_image_media": {
        "alt_text": "Living room and dining room with farmhouse decor.",
        "public_id": "019cfb4d-19dd-750a-9c05-70354c830050",
        "storage_key": "property/6767906449165643/019cfb4d-19dd-750a-9c05-70354c830050.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "OKC Apartments with Fitness Center",
      "seo_description": "Waters Edge in Oklahoma City offers apartments with a fitness center. Enjoy modern amenities and a lakeside view. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "generator",
      "page_item_url": "waterfront-apartments-okc",
      "search_query": "waterfront apartments OKC",
      "category": "Amenity",
      "h1_title": "Waterfront Apartments in OKC",
      "h2_subtitle": "Discover stunning waterfront apartments in OKC at Waters Edge. Enjoy serene views and modern living in this beautiful setting.",
      "page_copy": "Experience the beauty and tranquility of waterfront living at Waters Edge Apartments in Oklahoma City. Nestled along serene lakeside views, our community provides an idyllic setting with spacious one and two-bedroom layouts. Residents can savor not just the picturesque surroundings but also a host of luxurious amenities.<br>\nWaters Edge goes beyond just beautiful views by offering a shimmering pool, fully-equipped fitness center, and scenic walking trails. Each apartment is designed with modern comforts, including high-speed internet and cable readiness, ensuring a seamless living experience. Discover why Waters Edge stands out among waterfront apartments in OKC—schedule a tour today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019cfb4d-19dd-750a-9c05-70354c830050.webp",
      "featured_image_media": {
        "alt_text": "Living room and dining room with farmhouse decor.",
        "public_id": "019cfb4d-19dd-750a-9c05-70354c830050",
        "storage_key": "property/6767906449165643/019cfb4d-19dd-750a-9c05-70354c830050.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Waterfront Apartments in OKC",
      "seo_description": "Find your home at Waters Edge, offering waterfront living in OKC with scenic views and modern amenities. Schedule a tour of our apartments today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "generator",
      "page_item_url": "lake-access-apartments-73108",
      "search_query": "lake access apartments 73108",
      "category": "Amenity",
      "h1_title": "Lake Access Apartments in 73108",
      "h2_subtitle": "Enjoy lake access at Waters Edge Apartments, located in the 73108 area. Experience serene waterfront living with modern amenities here.",
      "page_copy": "Waters Edge Apartments, located in the heart of the 73108 area, offers residents unparalleled lake access. Our stunning community is perfect for those who appreciate the tranquility and beauty of waterfront living. Enjoy scenic views directly from your home while taking advantage of a plethora of luxurious amenities.\nWith spacious one and two-bedroom options, a fitness center, and a pet-friendly environment, Waters Edge meets all your lifestyle needs. Our residents love the combination of serene surroundings and the convenience of modern comforts, including high-speed internet and cable. Discover the unique charm of lakeside living in the 73108 area at Waters Edge Apartments. Schedule your visit today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019cfb4d-19dd-750a-9c05-70354c830050.webp",
      "featured_image_media": {
        "alt_text": "Living room and dining room with farmhouse decor.",
        "public_id": "019cfb4d-19dd-750a-9c05-70354c830050",
        "storage_key": "property/6767906449165643/019cfb4d-19dd-750a-9c05-70354c830050.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Lake Access Apartments in 73108",
      "seo_description": "Discover Waters Edge in 73108, featuring lake access with scenic views and modern amenities. Tour our waterfront apartments today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-oklahoma-city",
      "search_query": "one bedroom apartments oklahoma city",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in OKC",
      "h2_subtitle": "Explore comfortable one bedroom apartments in Oklahoma City at Waters Edge. Ideal for those seeking modern amenities in a tranquil setting.",
      "page_copy": "Waters Edge Apartments in Oklahoma City offers beautifully designed one bedroom apartments perfect for singles or couples looking for cozy living spaces. Located in a serene lakeside community, our apartments blend tranquility with modern conveniences.\nEach one bedroom apartment is smoke-free and cable-ready, providing a clean and connected living experience. Residents can enjoy a variety of amenities including a shimmering pool, fitness center, and scenic walking trails. With high-speed internet and pet-friendly policies, Waters Edge is tailored to meet diverse lifestyle needs. Make Waters Edge your home and experience the best of Oklahoma City living today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019cfb4d-19dd-750a-9c05-70354c830050.webp",
      "featured_image_media": {
        "alt_text": "Living room and dining room with farmhouse decor.",
        "public_id": "019cfb4d-19dd-750a-9c05-70354c830050",
        "storage_key": "property/6767906449165643/019cfb4d-19dd-750a-9c05-70354c830050.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in OKC",
      "seo_description": "Discover one bedroom apartments at Waters Edge in OKC, featuring modern amenities and a serene lakeside setting. Perfect for comfortable living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-w-south-oklahoma-city",
      "search_query": "two bedroom apartments W South Oklahoma City",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in W South OKC",
      "h2_subtitle": "Find spacious two bedroom apartments in W South Oklahoma City at Waters Edge. Enjoy modern amenities and a picturesque setting.",
      "page_copy": "At Waters Edge Apartments in W South Oklahoma City, explore our spacious two bedroom layouts designed for comfortable and modern living. Perfectly suited for families or roommates, these apartments offer ample space and scenic waterfront views.\nResidents of Waters Edge benefit from a variety of community amenities such as a refreshing pool, a state-of-the-art fitness center, and lush walking trails. Each apartment is equipped with high-speed internet capability and is cable-ready, reinforcing a lifestyle of ease and connectivity. Discover a harmonious blend of comfort and nature in W South Oklahoma City at Waters Edge. Schedule a tour of our two bedroom apartments today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019cfb4d-19dd-750a-9c05-70354c830050.webp",
      "featured_image_media": {
        "alt_text": "Living room and dining room with farmhouse decor.",
        "public_id": "019cfb4d-19dd-750a-9c05-70354c830050",
        "storage_key": "property/6767906449165643/019cfb4d-19dd-750a-9c05-70354c830050.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in W South OKC",
      "seo_description": "Explore Waters Edge in W South OKC offering two bedroom apartments with modern amenities in a serene setting. Ideal for comfortable living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "generator",
      "page_item_url": "apartments-near-oklahoma-city-community-college",
      "search_query": "apartments near oklahoma city community college",
      "category": "School",
      "h1_title": "Apartments Near OKC Community College",
      "h2_subtitle": "Find convenient apartments near Oklahoma City Community College at Waters Edge. Perfect for students and faculty seeking modern, comfortable living.",
      "page_copy": "Waters Edge Apartments is conveniently located near Oklahoma City Community College, providing an ideal living situation for students and faculty alike. Our community blends the serenity of lakeside views with practical access to academic life.\nChoose from spacious one and two-bedroom layouts, featuring amenities that cater to a modern lifestyle, such as a fitness center, pet play area, and high-speed internet. Smoke-free and cable-ready, our apartments offer the perfect balance between peaceful environment and urban convenience. Let Waters Edge be your home base near OKC Community College, where education meets relaxation in the perfect neighborhood.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019cfb4d-19dd-750a-9c05-70354c830050.webp",
      "featured_image_media": {
        "alt_text": "Living room and dining room with farmhouse decor.",
        "public_id": "019cfb4d-19dd-750a-9c05-70354c830050",
        "storage_key": "property/6767906449165643/019cfb4d-19dd-750a-9c05-70354c830050.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near OKC Community College",
      "seo_description": "Discover Waters Edge offering apartments near Oklahoma City Community College. Ideal for students and faculty with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "generator",
      "page_item_url": "waters-edge-apartments-near-oklahoma-city-university",
      "search_query": "waters edge apartments close to oklahoma city university",
      "category": "School",
      "h1_title": "Waters Edge Apartments Near OKC University",
      "h2_subtitle": "Discover Waters Edge Apartments close to Oklahoma City University. Ideal for students and staff seeking modern amenities and a serene environment.",
      "page_copy": "Situated conveniently close to Oklahoma City University, Waters Edge Apartments offers a perfect retreat for students and staff desiring a peaceful residential experience. With tranquil waterfront views and expansive living spaces, our community caters to academic professionals and learners alike.\nOur one and two-bedroom apartments come equipped with high-speed internet, making study sessions a breeze, while amenities such as a shimmering pool and fitness center provide the perfect balance of work and relaxation. The apartments are smoke-free and cable-ready, ensuring a clean and connected lifestyle. Experience the best of both worlds at Waters Edge, where proximity to Oklahoma City University meets serene living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019cfb4d-19dd-750a-9c05-70354c830050.webp",
      "featured_image_media": {
        "alt_text": "Living room and dining room with farmhouse decor.",
        "public_id": "019cfb4d-19dd-750a-9c05-70354c830050",
        "storage_key": "property/6767906449165643/019cfb4d-19dd-750a-9c05-70354c830050.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Waters Edge Apartments Near OKC University",
      "seo_description": "Explore Waters Edge just minutes from Oklahoma City University, perfect for students and faculty with premium amenities and a peaceful setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "generator",
      "page_item_url": "living-near-southern-nazarene-university-oklahoma",
      "search_query": "living near southern nazarene university in oklahoma",
      "category": "School",
      "h1_title": "Living Near Southern Nazarene University",
      "h2_subtitle": "Experience the benefits of living near Southern Nazarene University in Oklahoma at Waters Edge Apartments. Enjoy comfort and convenience in a serene setting.",
      "page_copy": "Living near Southern Nazarene University in Oklahoma is convenient and luxurious at Waters Edge Apartments. Our prime location offers easy access to campus while providing a peaceful retreat with scenic lake views and modern amenities.\nChoose from our spacious one and two-bedroom apartments designed with students and faculty in mind, featuring high-speed internet and smoke-free environments. Enjoy community perks like a fitness center, pet play area, and walking trails, making it easy to relax and recharge after a day of classes or work. Discover the perfect balance between study and serenity at Waters Edge Apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019cfb4d-19dd-750a-9c05-70354c830050.webp",
      "featured_image_media": {
        "alt_text": "Living room and dining room with farmhouse decor.",
        "public_id": "019cfb4d-19dd-750a-9c05-70354c830050",
        "storage_key": "property/6767906449165643/019cfb4d-19dd-750a-9c05-70354c830050.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Near Southern Nazarene University OK",
      "seo_description": "Discover Waters Edge, ideal for living near Southern Nazarene University Oklahoma. Enjoy easy access, modern amenities, and a serene environment.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "generator",
      "page_item_url": "oklahoma-state-university-oklahoma-city-nearby-apartments",
      "search_query": "oklahoma state university oklahoma city nearby apartments",
      "category": "School",
      "h1_title": "Nearby Apartments to OSU OKC",
      "h2_subtitle": "Waters Edge Apartments offers a convenient lifestyle with nearby access to Oklahoma State University Oklahoma City. Perfect for students and faculty alike.",
      "page_copy": "Explore Waters Edge Apartments, located just a short drive from Oklahoma State University Oklahoma City. Our vibrant community is the ideal spot for students, faculty, and staff seeking convenience paired with tranquil living.\nOur spacious one and two-bedroom layouts are designed for comfort, featuring modern amenities such as high-speed internet, a fitness center, and a pet play area. Whether you're unwinding by the waterfront or enjoying the convenience of campus proximity, Waters Edge Apartments offers a unique blend of serenity and accessibility. Make us your new home base near OSU Oklahoma City today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019cfb4d-19dd-750a-9c05-70354c830050.webp",
      "featured_image_media": {
        "alt_text": "Living room and dining room with farmhouse decor.",
        "public_id": "019cfb4d-19dd-750a-9c05-70354c830050",
        "storage_key": "property/6767906449165643/019cfb4d-19dd-750a-9c05-70354c830050.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Nearby Apartments to Oklahoma State University OKC",
      "seo_description": "Experience Waters Edge, nearby Oklahoma State University Oklahoma City. Enjoy convenience and tranquility with modern amenities perfect for students and staff.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "generator",
      "page_item_url": "apartments-near-integris-health-baptist-okc",
      "search_query": "apartments near INTEGRIS Health Baptist Medical Center OKC",
      "category": "Hospital",
      "h1_title": "Apartments Near INTEGRIS Health Baptist OKC",
      "h2_subtitle": "Discover Waters Edge Apartments near INTEGRIS Health Baptist Medical Center OKC. Ideal for healthcare professionals seeking comfort and convenience.",
      "page_copy": "Waters Edge Apartments offers an ideal living solution for healthcare professionals with its proximity to INTEGRIS Health Baptist Medical Center in OKC. Our community combines a convenient location with serene living, making it perfect for those who work in the medical field.\nOur spacious one and two-bedroom apartments feature high-speed internet and come cable-ready, ensuring you stay connected whether relaxing at home or catching up on work. Enjoy community amenities like a tranquil pool, modern fitness center, and scenic walking trails, all designed to provide a balanced lifestyle. At Waters Edge Apartments, you can enjoy both comfort and easy access to INTEGRIS Health Baptist Medical Center.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019cfb4d-19dd-750a-9c05-70354c830050.webp",
      "featured_image_media": {
        "alt_text": "Living room and dining room with farmhouse decor.",
        "public_id": "019cfb4d-19dd-750a-9c05-70354c830050",
        "storage_key": "property/6767906449165643/019cfb4d-19dd-750a-9c05-70354c830050.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near INTEGRIS Health Baptist OKC",
      "seo_description": "Find your home at Waters Edge, near INTEGRIS Health Baptist Medical Center OKC. Perfect for healthcare staff wanting convenient and modern living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "generator",
      "page_item_url": "apartments-close-ou-health-university-medical-center",
      "search_query": "apartments close to OU Health University of Oklahoma Medical Center W South Oklahoma City",
      "category": "Hospital",
      "h1_title": "Close Apartments to OU Health Medical Center",
      "h2_subtitle": "Waters Edge Apartments offers living close to OU Health University of Oklahoma Medical Center. Ideal for medical professionals seeking a calming retreat.",
      "page_copy": "Located in W South Oklahoma City, Waters Edge Apartments provides a superb living option close to OU Health University of Oklahoma Medical Center. Our community is designed for those who appreciate both convenience and relaxation, making it ideal for medical professionals and students.\nEnjoy the spacious designs of our one and two-bedroom apartments, fitted with modern amenities like high-speed internet and cable readiness. After a busy day, unwind by our inviting pool or take a stroll on the scenic walking trails. Waters Edge Apartments not only offers proximity to OU Health but also a peaceful environment to call home. Make the smart choice for convenience and tranquility today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019cfb4d-19dd-750a-9c05-70354c830050.webp",
      "featured_image_media": {
        "alt_text": "Living room and dining room with farmhouse decor.",
        "public_id": "019cfb4d-19dd-750a-9c05-70354c830050",
        "storage_key": "property/6767906449165643/019cfb4d-19dd-750a-9c05-70354c830050.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to OU Health Medical Center",
      "seo_description": "Waters Edge offers apartments close to OU Health University of Oklahoma Medical Center in W South Oklahoma City, perfect for convenient and tranquil living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "generator",
      "page_item_url": "apartments-near-scissortail-park-oklahoma-city",
      "search_query": "apartments near Scissortail Park Oklahoma City",
      "category": "Park",
      "h1_title": "Apartments Near Scissortail Park OKC",
      "h2_subtitle": "Find your relaxing retreat at Waters Edge Apartments, just a short distance from Scissortail Park in Oklahoma City. Enjoy convenient, tranquil living.",
      "page_copy": "At Waters Edge Apartments, you're just minutes away from the vibrant Scissortail Park in Oklahoma City. Our community offers the perfect blend of city convenience and peaceful living, making it an ideal choice for those who love the outdoors yet seek a serene home environment.\nChoose from our spacious one and two-bedroom units, complete with modern conveniences like high-speed internet and cable readiness. Our amenities, including a shimmering pool and scenic walking trails, offer ample opportunities for relaxation after exploring Scissortail Park's numerous attractions. With Waters Edge Apartments, enjoy the best of both worlds—dynamic city life and tranquil living, all close to one of OKC’s most beloved green spaces.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019cfb4d-19dd-750a-9c05-70354c830050.webp",
      "featured_image_media": {
        "alt_text": "Living room and dining room with farmhouse decor.",
        "public_id": "019cfb4d-19dd-750a-9c05-70354c830050",
        "storage_key": "property/6767906449165643/019cfb4d-19dd-750a-9c05-70354c830050.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Scissortail Park OKC",
      "seo_description": "Waters Edge offers convenient living near Scissortail Park OKC. Enjoy a blend of city life and tranquility in our modern, spacious apartments.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "generator",
      "page_item_url": "apartments-close-to-myriad-botanical-gardens-okc",
      "search_query": "apartments close to Myriad Botanical Gardens OKC",
      "category": "Park",
      "h1_title": "Apartments Close to Myriad Botanical Gardens",
      "h2_subtitle": "Experience the charm of Waters Edge Apartments, conveniently located near Myriad Botanical Gardens in Oklahoma City. Perfect for nature enthusiasts.",
      "page_copy": "Nestled in the heart of Oklahoma City, Waters Edge Apartments offers a delightful living experience close to Myriad Botanical Gardens. For those who love nature and urban conveniences, our location is unmatched, providing easy access to one of OKC's most beautiful destinations.\nOur one and two-bedroom apartments are designed with comfort in mind, featuring amenities like high-speed internet, cable readiness, and access to the scenic waterfront. Enjoy the benefits of living near the lush landscapes of Myriad Botanical Gardens while relaxing in community features such as the sparkling pool and fitness center. Waters Edge Apartments offers a harmonious blend of city excitement and natural serenity.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019cfb4d-19dd-750a-9c05-70354c830050.webp",
      "featured_image_media": {
        "alt_text": "Living room and dining room with farmhouse decor.",
        "public_id": "019cfb4d-19dd-750a-9c05-70354c830050",
        "storage_key": "property/6767906449165643/019cfb4d-19dd-750a-9c05-70354c830050.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Myriad Botanical Gardens OKC",
      "seo_description": "Discover tranquil living at Waters Edge, near Myriad Botanical Gardens OKC. Enjoy spacious apartments and easy access to natural and urban attractions.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "generator",
      "page_item_url": "apartments-near-will-rogers-gardens-oklahoma-city",
      "search_query": "apartments near Will Rogers Gardens Oklahoma",
      "category": "Park",
      "h1_title": "Apartments Near Will Rogers Gardens OK",
      "h2_subtitle": "Discover Waters Edge Apartments, ideally situated near Will Rogers Gardens in Oklahoma City. Enjoy both garden beauty and modern comforts.",
      "page_copy": "Waters Edge Apartments is the perfect choice for anyone looking to live near the picturesque Will Rogers Gardens in Oklahoma City. Our location provides residents with easy access to this beautiful and serene garden, known for its stunning landscapes and tranquil spaces.\nChoose from our modern one and two-bedroom layouts, designed with today’s lifestyle in mind and equipped with features like high-speed internet and cable readiness. Enjoy on-site amenities such as a shimmering pool and lush walking trails, creating an oasis of calm after a day at the gardens. Waters Edge Apartments offers a unique combination of leisurely garden visits and the comfort of modern living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019cfb4d-19dd-750a-9c05-70354c830050.webp",
      "featured_image_media": {
        "alt_text": "Living room and dining room with farmhouse decor.",
        "public_id": "019cfb4d-19dd-750a-9c05-70354c830050",
        "storage_key": "property/6767906449165643/019cfb4d-19dd-750a-9c05-70354c830050.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Will Rogers Gardens, OK",
      "seo_description": "Live near Will Rogers Gardens at Waters Edge. Enjoy modern living and natural beauty just minutes away in Oklahoma City.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "generator",
      "page_item_url": "apartments-close-to-bricktown-river-walk-park-73108",
      "search_query": "apartments close to Bricktown River Walk Park 73108",
      "category": "Park",
      "h1_title": "Apartments Near Bricktown River Walk Park",
      "h2_subtitle": "Explore Waters Edge Apartments, located conveniently close to Bricktown River Walk Park in the 73108 area. Perfect for those who enjoy vibrant city life.",
      "page_copy": "Located conveniently in the 73108 area, Waters Edge Apartments offers an ideal living experience close to the bustling Bricktown River Walk Park. Enjoy the vibrant energy of Bricktown while retreating to our serene, lakeside apartments that offer a peaceful escape from the city hustle.\nOur spacious one and two-bedroom apartments come equipped with modern amenities such as high-speed internet and cable readiness. Take advantage of community features like a shimmering pool and scenic walking trails, perfect for unwinding after a day at Bricktown River Walk Park. Waters Edge provides the perfect balance between urban excitement and tranquility.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019cfb4d-19dd-750a-9c05-70354c830050.webp",
      "featured_image_media": {
        "alt_text": "Living room and dining room with farmhouse decor.",
        "public_id": "019cfb4d-19dd-750a-9c05-70354c830050",
        "storage_key": "property/6767906449165643/019cfb4d-19dd-750a-9c05-70354c830050.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Bricktown River Walk Park 73108",
      "seo_description": "Find your home at Waters Edge Apartments, near Bricktown River Walk Park in OKC 73108. Enjoy spacious, modern living with city and nature at your doorstep.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165643",
      "source": "generator",
      "page_item_url": "apartments-near-overholser-park-w-south-oklahoma-city",
      "search_query": "apartments near Overholser Park W South Oklahoma City",
      "category": "Park",
      "h1_title": "Apartments Near Overholser Park OKC",
      "h2_subtitle": "Discover Waters Edge Apartments, located just minutes from Overholser Park in W South Oklahoma City. Enjoy both urban convenience and park-side serenity.",
      "page_copy": "Waters Edge Apartments invites you to experience comfortable living just a short distance from Overholser Park in W South Oklahoma City. Our prime location offers residents easy access to this peaceful park, perfect for relaxing outdoor activities and nature escapes.\nThe one and two-bedroom apartments at Waters Edge are designed for modern comfort, featuring essential amenities like high-speed internet and cable readiness. Embrace the community's amenities such as a shimmering pool and scenic walking trails, making it easy to enjoy both leisure and recreation. Discover the balance of park-side tranquility and urban convenience at Waters Edge.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165643/019cfb4d-19dd-750a-9c05-70354c830050.webp",
      "featured_image_media": {
        "alt_text": "Living room and dining room with farmhouse decor.",
        "public_id": "019cfb4d-19dd-750a-9c05-70354c830050",
        "storage_key": "property/6767906449165643/019cfb4d-19dd-750a-9c05-70354c830050.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Overholser Park, OKC",
      "seo_description": "Live near Overholser Park at Waters Edge Apartments in W South OKC. Enjoy modern comforts and easy access to nature.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "3448"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-YBHN934NL7"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10041151665"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/waters-edge/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-KR7S5JN9"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449165643/019d1bda-e71c-711b-afb0-8370f052a9c3.pdf"
    },
    {
      "ID": "custom_rentgrata_property_id",
      "type": "STRING",
      "value": "2663eca1-77d2-417e-97cc-d7de19a39c38"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "833-785-1770"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "64e8c7a8ba79789303b1af0d"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IlhnQ2FUMGtJdW5PbTR4ZXNGd3pvenc9PSIsInZhbHVlIjoiMUlOeUhDNS9HZHNkWmk2ankxSmREUT09IiwibWFjIjoiODQzNTU3YTk1YTZmNTY1NzVhYTMwMGRhM2VkZWJlZjg1MWNjYTgyNTRlYmI1YWQxNDAzMGQ1YmU5M2NiZjYzMiJ9"
    }
  ],
  "custom_qb_id": "3448",
  "custom_ga4_id": "G-YBHN934NL7",
  "custom_repli_id": "10041151665",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/waters-edge/register/",
  "custom_google_gtm_id": "GTM-KR7S5JN9",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449165643/019d1bda-e71c-711b-afb0-8370f052a9c3.pdf",
  "custom_rentgrata_property_id": "2663eca1-77d2-417e-97cc-d7de19a39c38",
  "custom_ppc_tracking_phone_number": "833-785-1770",
  "custom_residentboost_apartment_id": "64e8c7a8ba79789303b1af0d",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IlhnQ2FUMGtJdW5PbTR4ZXNGd3pvenc9PSIsInZhbHVlIjoiMUlOeUhDNS9HZHNkWmk2ankxSmREUT09IiwibWFjIjoiODQzNTU3YTk1YTZmNTY1NzVhYTMwMGRhM2VkZWJlZjg1MWNjYTgyNTRlYmI1YWQxNDAzMGQ1YmU5M2NiZjYzMiJ9"
};

export const generatedAt = '2026-08-27T21:35:05.626Z';
